function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocucaogravada({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.65,340.16l13.67-.27,6.73-.12c2.24,0,4.47,0,6.7,0l-.44.44-.06-11.45.5.5-13.55-.06c-4.51,0-9-.11-13.55-.17l.28-.27c0,1.88-.09,3.76-.14,5.67Zm0,0-.14-5.66c0-1.91-.11-3.85-.13-5.79v-.27h.27c4.52-.05,9-.16,13.55-.16l13.55-.07h.51v.5l-.05,11.45v.45h-.45c-2.28,0-4.57,0-6.85-.06l-6.81-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,354.6l13.67-.27,6.73-.12c2.24,0,4.47,0,6.7,0l-.44.44-.06-11.45.5.5-13.55-.06c-4.52,0-9-.11-13.55-.16l.27-.28c0,1.88-.08,3.76-.13,5.67Zm0,0-.14-5.66c-.05-1.91-.11-3.85-.13-5.79v-.27h.28c4.52-.05,9-.16,13.55-.16l13.55-.07h.5v.5l-.05,11.45v.45h-.44c-2.28,0-4.57,0-6.85-.06l-6.81-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.53,
    y: 343.15,
    width: 27.1,
    height: 11.45,
    transform: "translate(834.17 697.76) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,170.25l13.67-.28,6.73-.11c2.24-.05,4.47,0,6.71-.06l-.45.45,0-11.46.5.5-13.55-.06c-4.52,0-9-.11-13.56-.16l.28-.28c0,1.88-.09,3.77-.13,5.67Zm0,0-.14-5.67c0-1.91-.11-3.84-.13-5.79v-.26h.27c4.52-.05,9-.16,13.56-.16l13.55-.06h.5v.5l-.06,11.46v.45h-.44c-2.29,0-4.58,0-6.85-.05l-6.82-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.84,
    y: 173.24,
    width: 27.1,
    height: 11.45,
    transform: "translate(328.79 357.92) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,184.69l13.66-.28,6.74-.11c2.24-.05,4.46,0,6.7-.06l-.45.45,0-11.45.5.49-13.55-.06c-4.52,0-9-.11-13.55-.16l.27-.27c0,1.87-.09,3.76-.13,5.66Zm0,0-.14-5.67c0-1.91-.12-3.84-.14-5.78V173h.28c4.51-.05,9-.16,13.55-.16l13.55-.06h.5v.51l-.06,11.45v.45h-.44c-2.29,0-4.57,0-6.85,0L134,185Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.25,
    y: 343.15,
    width: 27.1,
    height: 11.45,
    transform: "translate(135.59 697.76) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.25,44.66l13.66-.28,6.74-.11c2.24-.05,4.46,0,6.7-.05l-.45.44-.05-11.45.5.5L67.8,33.65c-4.52,0-9-.12-13.55-.17l.27-.27c0,1.88-.09,3.76-.13,5.67Zm0,0L54.1,39c0-1.92-.11-3.85-.13-5.79v-.27h.28c4.51,0,9-.16,13.55-.17l13.55-.06h.5v.5l-.06,11.45v.45h-.44c-2.29,0-4.57,0-6.85-.06l-6.82-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.13,
    y: 47.65,
    width: 27.1,
    height: 11.45,
    transform: "translate(105.36 106.75) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,44.67l13.67-.27,6.73-.12c2.24,0,4.47,0,6.7-.05l-.44.44-.06-11.45.5.5-13.55-.06c-4.52,0-9-.11-13.55-.16l.27-.28c0,1.88-.08,3.76-.13,5.67Zm0,0L433.63,39c-.05-1.91-.11-3.85-.13-5.79V33h.28c4.52-.05,9-.16,13.55-.16l13.55-.07h.5v.5l-.05,11.45v.45h-.44c-2.28,0-4.57,0-6.85,0L447.21,45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.93,
    y: 201.98,
    width: 27.1,
    height: 11.45,
    transform: "translate(788.96 415.41) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.73,
    y: 322.67,
    width: 27.1,
    height: 11.45,
    transform: "translate(554.57 656.8) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.31,72.87l-13.67.28-6.73.11c-2.24,0-4.47,0-6.7.06l.44-.45.06,11.46-.5-.5,13.55.06c4.51,0,9,.11,13.55.16l-.28.28c0-1.88.09-3.76.14-5.67Zm0,0,.14,5.67c0,1.91.11,3.84.13,5.79v.27h-.27c-4.52.05-9,.16-13.55.16l-13.55.07h-.5v-.5l.05-11.46v-.44h.45c2.28,0,4.57,0,6.85,0l6.81.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,58.43l-13.67.28-6.73.11c-2.24,0-4.47,0-6.7.06l.44-.45.06,11.46-.5-.5,13.55.06c4.52,0,9,.11,13.55.16l-.27.28c0-1.88.08-3.76.13-5.67Zm0,0,.14,5.67c.05,1.91.11,3.84.13,5.79v.27h-.28c-4.52,0-9,.16-13.55.16l-13.55.07h-.5v-.5l0-11.46V58h.44c2.28,0,4.57,0,6.85,0l6.81.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.29,
    y: 63.06,
    width: 339.41,
    height: 229.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.01,
    y: 64.1,
    width: 3.98,
    height: 230.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.18,159.06a6.13,6.13,0,1,1-6.13-6.12A6.12,6.12,0,0,1,338.18,159.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,145.62a13.44,13.44,0,0,0-4.19,26.21v-3.42a10.24,10.24,0,1,1,8.38,0v3.42a13.44,13.44,0,0,0-4.19-26.21Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,140.12a18.94,18.94,0,0,0-5.53,37.06l1.1-3a15.75,15.75,0,1,1,8.86,0l1.1,3a18.94,18.94,0,0,0-5.53-37.06Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,133.9A25.16,25.16,0,0,0,324.38,183l1.1-3a22,22,0,1,1,13.14,0l1.1,3a25.16,25.16,0,0,0-7.67-49.13Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.05,128a31.11,31.11,0,0,0-9.71,60.67l1.09-3a27.92,27.92,0,1,1,17.24,0l1.1,3A31.11,31.11,0,0,0,332.05,128Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.45,
    y: 159.56,
    width: 3.2,
    height: 135.16,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.91,
    y: 233,
    width: 126.62,
    height: 3.2,
    transform: "translate(-8.36 457.63) rotate(-71.75)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.28,
    y: 171.28,
    width: 3.2,
    height: 126.62,
    transform: "translate(-55.77 122.02) rotate(-18.25)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.42,
    y: 202.64,
    width: 19.34,
    height: 3.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.61,
    y: 221.11,
    width: 30.97,
    height: 3.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.77,
    y: 238.86,
    width: 42.64,
    height: 3.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.79,
    y: 261.53,
    width: 58.61,
    height: 3.2,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.82,
    y: 250.2,
    width: 54.08,
    height: 3.2,
    transform: "translate(-75.27 161.08) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.73,
    y: 224.76,
    width: 3.2,
    height: 54.08,
    transform: "translate(-33.86 450.66) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.65,
    y: 277.27,
    width: 74.04,
    height: 3.2,
    transform: "translate(-86.72 163.06) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.92,
    y: 241.85,
    width: 3.2,
    height: 74.04,
    transform: "translate(-57.75 467.46) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.86,
    y: 230.87,
    width: 39.72,
    height: 3.2,
    transform: "translate(-67.08 159.64) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.87,
    y: 212.61,
    width: 3.2,
    height: 39.72,
    transform: "translate(-16.81 438.66) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.77,
    y: 211.34,
    width: 29.26,
    height: 3.2,
    transform: "translate(-61.51 182.67) rotate(-28.38)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.19,
    y: 198.3,
    width: 3.2,
    height: 29.26,
    transform: "translate(-12.23 405.37) rotate(-61.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.31,59.07V296.44H423.69V59.07ZM419.7,292.45H80.29V63.06H419.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 67.13,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 73.37,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 79.62,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 85.86,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 92.1,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.7,
    y: 98.34,
    width: 354.61,
    height: 5.55,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.47,
    y: 66,
    width: 1,
    height: 98.02,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.74 168.66 413.2 168.66 414.09 163.58 415.85 163.58 416.74 168.66",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 418.06,
    y: 66,
    width: 1,
    height: 145.18,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.33 214.92 416.79 214.92 417.68 209.84 419.44 209.84 420.33 214.92",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.51,
    y: 58.3,
    width: 366.98,
    height: 11.61,
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.13 400.92 91.85 400.67 144.56 400.58 250 400.42 355.44 400.58 408.15 400.67 460.87 400.92 408.15 401.16 355.44 401.25 250 401.42 144.56 401.25 91.85 401.16 39.13 400.92",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.17,366.13q0-.33-.06-.69c0-.25-.06-.5-.1-.77s-.08-.52-.12-.8a0,0,0,0,1,0,0c-.1-.58-.22-1.19-.37-1.85,0-.07,0-.13,0-.2-.06-.27-.12-.54-.19-.82s-.17-.7-.26-1.07c-.19-.74-.39-1.52-.62-2.33-.1-.4-.22-.8-.34-1.21-.49-1.75-1.07-3.63-1.7-5.62-.21-.68-.44-1.38-.67-2.08l-.36-1.11-.76-2.27-.79-2.34-.82-2.35c-1.4-4-2.92-8.28-4.48-12.55l-.93-2.56c-.59-1.61-1.19-3.22-1.78-4.82-.11-.28-.21-.57-.31-.85-.89-2.4-1.77-4.77-2.64-7.09l-.48-1.3-.3-.81-.3-.81-2-5.5-.31-.84c-.13-.38-.27-.75-.41-1.11-.39-1.08-.78-2.13-1.15-3.16-.25-.71-.5-1.4-.75-2.06l-.46-1.29L151,294q-.22-.61-.42-1.2c-.09-.25-.17-.5-.26-.73-.24-.71-.47-1.37-.68-2v0c-.11-.33-.22-.66-.31-1-.24-.72-.45-1.38-.63-2-.05-.15-.09-.31-.14-.46a1.67,1.67,0,0,1,0-.18c-.11-.36-.2-.7-.29-1-.13-.48-.23-.91-.31-1.28,0-.09,0-.17-.05-.25l0-.14a4.2,4.2,0,0,1-.1-.89,3.14,3.14,0,0,1,0-.51q.09-.56.27-1.23c.12-.45.29-.93.48-1.46.67-1.83,1.7-4.09,2.86-6.59.33-.71.68-1.44,1-2.19,1-2.24,2.13-4.61,3.12-7,.33-.79.65-1.59,1-2.37.6-1.58,1.14-3.14,1.57-4.65.21-.75.4-1.49.55-2.21a21.5,21.5,0,0,0,.44-3,10.46,10.46,0,0,0-.47-4.35,4.35,4.35,0,0,0-.25-.59,9.77,9.77,0,0,0-.91-1.57l-.26-.37a19.9,19.9,0,0,0-2-2.22c-.44-.43-.92-.86-1.42-1.28-.26-.22-.52-.44-.8-.66a70.34,70.34,0,0,0-8.14-5.49l-1.31-.77-.81-.46-1.17-.67-.66-.37-1.29-.71c-1.94-1.07-3.82-2.06-5.51-3l-1.09-.6-1-.57c-.66-.37-1.28-.72-1.84-1.06l-.8-.48-.7-.46-.31-.21c-.23-.16-.44-.32-.62-.46a3.88,3.88,0,0,1-.36-.32h0c-.06-.06-.12-.11-.17-.17a4.43,4.43,0,0,1-.6-.84,10.55,10.55,0,0,1-.72-1.5l-.28-.73a2.46,2.46,0,0,1-.14-.38c-.18-.53-.37-1.09-.56-1.7-.15-.45-.29-.92-.43-1.4h0c-.09-.33-.19-.66-.29-1-.34-1.22-.7-2.52-1.09-3.89-.28-1-.56-2-.87-3,0-.16-.09-.32-.14-.48-.42-1.41-.87-2.85-1.37-4.29-.18-.54-.37-1.08-.57-1.61l-.58-1.56,0,0c-.21-.53-.43-1.06-.65-1.58s-.4-.94-.62-1.4c-.47-1-1-2-1.5-3-.12-.23-.25-.46-.38-.68s-.29-.5-.44-.74l-.28-.45c-.24-.38-.48-.76-.74-1.12s-.63-.89-1-1.31c-2.81-3.59-15-5-25.16-3.52-.26,0-.53.07-.79.12A36.59,36.59,0,0,0,82,190c-.23.07-.45.15-.66.23s-.43.15-.64.24a15.13,15.13,0,0,0-3.84,2.08,8.32,8.32,0,0,0-.77.66,6.89,6.89,0,0,0-.69.75h0a9,9,0,0,0-.53.76c-.06.1-.13.2-.19.31l-.19.32a4,4,0,0,0-.2.35q-.41.72-.84,1.59c-.15.29-.3.59-.45.91-.3.63-.61,1.3-.92,2-1.1,2.47-2.28,5.35-3.43,8.28-.17.41-.33.83-.49,1.25s-.33.83-.49,1.25-.33.83-.49,1.24c-.24.62-.47,1.23-.71,1.83L65.3,217c-.14.37-.29.74-.43,1.1-.21.54-.41,1.06-.62,1.56-.13.33-.25.65-.38,1s-.15.38-.23.57c-.23.55-.44,1.07-.64,1.54l-.45,1c-.24.51-.45.93-.62,1.24l-.08.13a3.83,3.83,0,0,1-.24.31l0,0c-.25.28-.58.64-1,1.05-1,1-2.31,2.27-3.85,3.76-.45.43-.9.88-1.37,1.34l-.7.7L54,233c-1,1-2,2-2.9,3-.47.52-.94,1-1.4,1.57-.23.27-.46.53-.68.8-.44.52-.87,1-1.28,1.58a33,33,0,0,0-2.65,3.91c-.28.51-.53,1-.74,1.49a10.16,10.16,0,0,0-.38,1l-.12.39a.74.74,0,0,0,0,.14c0,.12-.07.24-.1.37a45.56,45.56,0,0,0-1.1,8.08c0,.76-.09,1.56-.13,2.39l0,.75,0,.94c0,1-.05,2-.06,3-.07,5.9.12,12.86.47,20.46.94,20.52,3.05,45.71,4.37,67.21a468.9,468.9,0,0,1,.57,50.68l8.6,0h2.4l96.64-.3,6.68,0,.33-.48c.06-.11.15-.23.24-.37.85-1.3,2.57-4,4.48-7.52l.46-.84q.23-.42.45-.87c.21-.39.41-.8.62-1.2.62-1.22,1.23-2.51,1.83-3.83.2-.44.39-.89.59-1.33,0,0,0,0,0,0,.19-.45.38-.9.56-1.36s.37-.92.55-1.39a51.81,51.81,0,0,0,2.34-7.73c.05-.24.1-.47.14-.7s.09-.47.13-.7.08-.46.11-.69c.09-.56.16-1.12.21-1.67,0-.24,0-.48.06-.73s0-.23,0-.35,0-.43,0-.65C175.22,367.45,175.21,366.78,175.17,366.13ZM93.48,222.32c-1.47,2.55-7.66,3.4-10.42,2.27s2.11-21.53,6-23.63S95,219.77,93.48,222.32Zm19.19.47c-2.75,1.14-9,.29-10.42-2.26s.39-23.54,4.42-21.36S115.42,221.66,112.67,222.79Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.17,366.13q0-.33-.06-.69c0-.25-.06-.5-.1-.77s-.08-.52-.12-.8a0,0,0,0,1,0,0c-.1-.58-.22-1.19-.37-1.85,0-.07,0-.13,0-.2-.06-.27-.12-.54-.19-.82s-.17-.7-.26-1.07c-.19-.74-.39-1.52-.62-2.33-.1-.4-.22-.8-.34-1.21-.49-1.75-1.07-3.63-1.7-5.62-.21-.68-.44-1.38-.67-2.08l-.36-1.11-.76-2.27-.79-2.34-.82-2.35c-1.4-4-2.92-8.28-4.48-12.55l-.93-2.56c-.59-1.61-1.19-3.22-1.78-4.82-.11-.28-.21-.57-.31-.85-.89-2.4-1.77-4.77-2.64-7.09l-.48-1.3-.3-.81-.3-.81-2-5.5-.31-.84c-.13-.38-.27-.75-.41-1.11-.39-1.08-.78-2.13-1.15-3.16-.25-.71-.5-1.4-.75-2.06l-.46-1.29L151,294q-.22-.61-.42-1.2c-.09-.25-.17-.5-.26-.73-.24-.71-.47-1.37-.68-2v0c-.11-.33-.22-.66-.31-1-.24-.72-.45-1.38-.63-2-.05-.15-.09-.31-.14-.46a1.67,1.67,0,0,1,0-.18c-.11-.36-.2-.7-.29-1-.13-.48-.23-.91-.31-1.28,0-.09,0-.17-.05-.25l0-.14a4.2,4.2,0,0,1-.1-.89,3.14,3.14,0,0,1,0-.51q.09-.56.27-1.23c.12-.45.29-.93.48-1.46.67-1.83,1.7-4.09,2.86-6.59.33-.71.68-1.44,1-2.19,1-2.24,2.13-4.61,3.12-7,.33-.79.65-1.59,1-2.37.6-1.58,1.14-3.14,1.57-4.65.21-.75.4-1.49.55-2.21a21.5,21.5,0,0,0,.44-3,10.46,10.46,0,0,0-.47-4.35,4.35,4.35,0,0,0-.25-.59,9.77,9.77,0,0,0-.91-1.57l-.26-.37a19.9,19.9,0,0,0-2-2.22c-.44-.43-.92-.86-1.42-1.28-.26-.22-.52-.44-.8-.66a70.34,70.34,0,0,0-8.14-5.49l-1.31-.77-.81-.46-1.17-.67-.66-.37-1.29-.71c-1.94-1.07-3.82-2.06-5.51-3l-1.09-.6-1-.57c-.66-.37-1.28-.72-1.84-1.06l-.8-.48-.7-.46-.31-.21c-.23-.16-.44-.32-.62-.46a3.88,3.88,0,0,1-.36-.32h0c-.06-.06-.12-.11-.17-.17a4.43,4.43,0,0,1-.6-.84,10.55,10.55,0,0,1-.72-1.5l-.28-.73a2.46,2.46,0,0,1-.14-.38c-.18-.53-.37-1.09-.56-1.7-.15-.45-.29-.92-.43-1.4h0c-.09-.33-.19-.66-.29-1-.34-1.22-.7-2.52-1.09-3.89-.28-1-.56-2-.87-3,0-.16-.09-.32-.14-.48-.42-1.41-.87-2.85-1.37-4.29-.18-.54-.37-1.08-.57-1.61l-.58-1.56,0,0c-.21-.53-.43-1.06-.65-1.58s-.4-.94-.62-1.4c-.47-1-1-2-1.5-3-.12-.23-.25-.46-.38-.68s-.29-.5-.44-.74l-.28-.45c-.24-.38-.48-.76-.74-1.12s-.63-.89-1-1.31c-2.81-3.59-15-5-25.16-3.52-.26,0-.53.07-.79.12A36.59,36.59,0,0,0,82,190c-.23.07-.45.15-.66.23s-.43.15-.64.24a15.13,15.13,0,0,0-3.84,2.08,8.32,8.32,0,0,0-.77.66,6.89,6.89,0,0,0-.69.75h0a9,9,0,0,0-.53.76c-.06.1-.13.2-.19.31l-.19.32a4,4,0,0,0-.2.35q-.41.72-.84,1.59c-.15.29-.3.59-.45.91-.3.63-.61,1.3-.92,2-1.1,2.47-2.28,5.35-3.43,8.28-.17.41-.33.83-.49,1.25s-.33.83-.49,1.25-.33.83-.49,1.24c-.24.62-.47,1.23-.71,1.83L65.3,217c-.14.37-.29.74-.43,1.1-.21.54-.41,1.06-.62,1.56-.13.33-.25.65-.38,1s-.15.38-.23.57c-.23.55-.44,1.07-.64,1.54l-.45,1c-.24.51-.45.93-.62,1.24l-.08.13a3.83,3.83,0,0,1-.24.31l0,0c-.25.28-.58.64-1,1.05-1,1-2.31,2.27-3.85,3.76-.45.43-.9.88-1.37,1.34l-.7.7L54,233c-1,1-2,2-2.9,3-.47.52-.94,1-1.4,1.57-.23.27-.46.53-.68.8-.44.52-.87,1-1.28,1.58a33,33,0,0,0-2.65,3.91c-.28.51-.53,1-.74,1.49a10.16,10.16,0,0,0-.38,1l-.12.39a.74.74,0,0,0,0,.14c0,.12-.07.24-.1.37a45.56,45.56,0,0,0-1.1,8.08c0,.76-.09,1.56-.13,2.39l0,.75,0,.94c0,1-.05,2-.06,3-.07,5.9.12,12.86.47,20.46.94,20.52,3.05,45.71,4.37,67.21a468.9,468.9,0,0,1,.57,50.68l8.6,0h2.4l96.64-.3,6.68,0,.33-.48c.06-.11.15-.23.24-.37.85-1.3,2.57-4,4.48-7.52l.46-.84q.23-.42.45-.87c.21-.39.41-.8.62-1.2.62-1.22,1.23-2.51,1.83-3.83.2-.44.39-.89.59-1.33,0,0,0,0,0,0,.19-.45.38-.9.56-1.36s.37-.92.55-1.39a51.81,51.81,0,0,0,2.34-7.73c.05-.24.1-.47.14-.7s.09-.47.13-.7.08-.46.11-.69c.09-.56.16-1.12.21-1.67,0-.24,0-.48.06-.73s0-.23,0-.35,0-.43,0-.65C175.22,367.45,175.21,366.78,175.17,366.13ZM93.48,222.32c-1.47,2.55-7.66,3.4-10.42,2.27s2.11-21.53,6-23.63S95,219.77,93.48,222.32Zm19.19.47c-2.75,1.14-9,.29-10.42-2.26s.39-23.54,4.42-21.36S115.42,221.66,112.67,222.79Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.05,400.55l-6.61,0h-.07S164,379.48,164,369.15,139.26,293.68,139.39,283,155,258.43,153.8,249.38s-24.64-17.32-29.36-22-8.12-31.6-12.32-34.89-27.87-3.12-32,4-7.6,26.21-11,33.52S50.53,242.14,50,254.23s28,90.48,24.1,109.88-11.44,31.25-15.38,36.76h-2.4s11.23-27.43,11.49-39.2c.22-9.39-17.75-59-25-78.7h0C42,265,42,250.63,44.31,245.41,47.69,237.64,60.79,227,61.94,225c2.22-3.91,9.77-26.39,13.43-31,6.16-7.8,34-7.63,38.46-2,8.25,10.59,9.92,29.14,13.24,32.73s28.1,13.29,31.45,22.47-10.67,29.86-10.83,35.57,26.57,69.22,27.48,83.32S162.05,400.55,162.05,400.55Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.74,283.06c14.23,31.73,48.6,84.49,64,71.43,23-19.54,38.56-62.74,44.73-80.21,3.46-9.79-46.39-26.17-49.45-17.29-4.35,12.64-11.16,39-15.11,42.76-2.08,2-18.39-21-30.76-31.84C147.3,252.24,147.2,272.92,151.74,283.06Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.7,253.32c-2.44,10.65-16,30.49-21.07,34S210.9,270,210.31,263.66s10.55-42.58,19.3-49.51S274.24,242.28,271.7,253.32Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.27,256.33s-2-14.08-7.84-25.18c-4.89-9.33-13.21-22.63-8.29-25.45,10.1-5.78,30.83,27.4,30.83,27.4s6.79,16.11-2.7,22.72C217.31,260,211.27,256.33,211.27,256.33Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,227.51c1.81,5.5,7.26.21,7.26.21s-6,9.5-1.95,14.45c3.93,4.76,10.29-1.86,10.75-2.32-.31.5-5.6,9.37-1,13.93,4.78,4.72,10-3,10.35-3.52-.14.57-1.95,8.14,2.33,10.81,7.35,4.57,12.5-14.65,18.71-17.9,0,0,6.71,9.9,7,10.15,0,0,5.27-18.19.42-26.33a6,6,0,0,0-7.06-2.75s2.35-5.68-1.15-9.38c-1.81-1.89-6.44-.69-6.44-.69s1.69-4.62-1.63-7.72c-2.65-2.48-6.89-.89-6.89-.89s-.43-5.19-4-6.85C237.89,195.36,214.43,215.73,218.3,227.51Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,205.71a.08.08,0,0,0-.09-.14c-9.35,4.81-18.15,13-22.93,22.41-.15.31.28.7.52.39C232.53,219.58,239.26,212.32,248.25,205.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,214c.1-.07,0-.23-.13-.17-9.61,5-19.27,14.47-23.5,26-.14.39.12.89.33.45C237.63,232.85,249.42,219.93,257.54,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.68,251.17c4.49-10.9,12-19.27,21-26.75.12-.1,0-.25-.15-.2-5.38,2.47-10.6,7.83-14.3,12.35A31.1,31.1,0,0,0,243.3,251C243.26,251.23,243.59,251.4,243.68,251.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.36,227.76c-.19.37.56.23.39.61-.74,1.59-4.38,11.53-1.37,13.82,2.41,1.83,6.54-.14,7.83-1.52l3.24-3.47-1.84,4.39a19.43,19.43,0,0,0-1.51,6.11,6.92,6.92,0,0,0,1.59,5.45,4,4,0,0,0,4.92.87,12,12,0,0,0,4.28-4.23l3.05-4.73-1.33,5.44a18.43,18.43,0,0,0-.52,4.63,7.58,7.58,0,0,0,1.16,4.18,3.57,3.57,0,0,0,3.46,1.51,8,8,0,0,0,3.71-2.42,62.93,62.93,0,0,0,5.88-7.78c.94-1.35,1.87-2.71,2.88-4a11.5,11.5,0,0,1,3.56-3.42,12.66,12.66,0,0,0-3.19,3.68c-.89,1.38-1.72,2.8-2.55,4.22a52.83,52.83,0,0,1-5.59,8.26,9.25,9.25,0,0,1-4.36,3,5.09,5.09,0,0,1-5.19-2,9.26,9.26,0,0,1-1.57-5.16,20,20,0,0,1,.5-5.16l1.72.71a13.75,13.75,0,0,1-5,5,5.77,5.77,0,0,1-3.85.6,6.48,6.48,0,0,1-3.34-1.91,8.78,8.78,0,0,1-2-6.91,21.23,21.23,0,0,1,1.77-6.69l1.41.92c-1.7,1.7-6.08,4.4-10.18,2C218.42,240,224.18,229.58,225.36,227.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,227.72a11.41,11.41,0,0,1-3.24,1.46,2.66,2.66,0,0,1-2.65-.63,5.46,5.46,0,0,1-1.14-2.9c-.17-1.15-.28-2.38-.34-3.64a9.41,9.41,0,0,0-.93,3.71,5.47,5.47,0,0,0,1.24,4,3.87,3.87,0,0,0,2.06,1,4.07,4.07,0,0,0,2.16-.34A6.27,6.27,0,0,0,225.56,227.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,258l51.89,36.14s-31,64.23-50.15,64.06-46.83-48.29-56.41-69.08-3.85-38.41,15.45-19.44S195,296.37,195.6,296.12C196.82,295.62,208,258,208,258Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.86,294.09s-21.49,44.55-39.75,59.34c-3.66,3-7.19,4.75-10.4,4.71-19.16-.17-46.83-48.28-56.42-69.06-5.93-12.88-6-24.54-.59-27,3.32-1.55,8.71.36,16.06,7.59,19.41,19.08,26.21,26.74,26.84,26.48C196.81,295.62,208,258,208,258Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,345.85c-.63.74-1.28,1.45-1.92,2.15a48.82,48.82,0,0,1-19.23,7,39.92,39.92,0,0,1-5.68.23l-1.18-.74a40.52,40.52,0,0,0,6.79-.17,34.73,34.73,0,0,0,7.9-1.83l1.94-.63,1.87-.79c.63-.27,1.27-.49,1.88-.8l1.81-.92A50.73,50.73,0,0,0,227.74,345.85Zm-39.37-56.58a55.33,55.33,0,0,0-16,10.93,85.2,85.2,0,0,0-8.31,9.52c.12.23.26.47.4.69a83.21,83.21,0,0,1,8.43-9.66,55.76,55.76,0,0,1,13.13-9.57l1.82-.92a10.37,10.37,0,0,1,1-.45Zm44.83,3.27a82.13,82.13,0,0,0-15.43-5.71c-.55-.13-1.11-.27-1.67-.38l-1.09-.23a43.92,43.92,0,0,0-13.63-.69c-.66.09-1.32.19-2,.32-.08.23-.16.48-.23.7.76-.13,1.53-.24,2.3-.34a43.39,43.39,0,0,1,12.66.53l1.12.2c.79.17,1.58.34,2.37.53a82.12,82.12,0,0,1,15.3,5.63,206.76,206.76,0,0,1,21.25,12,5.25,5.25,0,0,0,.28-.51A204.29,204.29,0,0,0,233.2,292.54Zm5.38-13.26A50.52,50.52,0,0,0,215,286.22l-.88.52a56.42,56.42,0,0,0-5.23,3.54c-8.79,6.68-15.8,15.27-22.47,23.91-3.34,4.34-6.62,8.7-10.08,12.93l-.76.91.39.56.88-1c3.48-4.24,6.77-8.6,10.13-12.93,6.67-8.61,13.67-17.13,22.36-23.72a55.64,55.64,0,0,1,5.9-3.95c.28-.17.56-.34.85-.49a52.73,52.73,0,0,1,7.44-3.44l1.92-.7c.63-.23,1.3-.38,2-.57l2-.55,2-.4a34.79,34.79,0,0,1,8.07-.84h.12Zm-63.7-3.58a54.37,54.37,0,0,1-11.16,3.58l-2,.39c-.66.12-1.34.16-2,.25l-2,.24-2,.08a32.94,32.94,0,0,1-5.62-.1l.18.67a51.56,51.56,0,0,0,25.25-4.55C175.27,276.07,175.08,275.88,174.88,275.7ZM160.1,263a119.09,119.09,0,0,1-11.31,6.78q0,.4,0,.84a116.56,116.56,0,0,0,12.06-7.23C160.58,263.22,160.34,263.08,160.1,263Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.59,300.12c-1.37-1.14-2.76-2.24-4.15-3.35q-4.23-3.34-8.48-6.67c-5.64-4.4-11.39-8.64-17.2-12.82-3.29-2.37-6.52-4.87-9.92-7.09a.15.15,0,0,0-.18.24c2.69,2.38,5.58,4.55,8.38,6.81s5.57,4.55,8.42,6.76q8.46,6.58,17.12,12.91c1.62,1.18,3.2,2.44,4.87,3.55.86.57,1.67,1.21,2.53,1.77s1.78,1,2.63,1.64a.09.09,0,0,0,.1-.14C250.31,302.55,249,301.28,247.59,300.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.05,294.94a130,130,0,0,0-4.88,16.38c-.68,2.74-1.21,5.52-1.73,8.3a61.35,61.35,0,0,0-1.11,8.32c0,.11.15.11.18,0,.85-2.67,1.49-5.46,2.11-8.19s1.3-5.49,1.92-8.25c1.24-5.5,2.69-11,3.77-16.51A.13.13,0,0,0,196.05,294.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.11,353.43c-3.66,3-7.19,4.75-10.4,4.71-19.16-.17-46.83-48.28-56.42-69.06-5.93-12.88-6-24.54-.59-27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39,400.28H65.81c-1.37-2.52,19-111.65,61.06-142.38,9.32-6.82,25.86-2.43,30.46,4.2C180.45,295.42,190.39,400.28,190.39,400.28Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,351.83a88.73,88.73,0,0,1-9.13-3.8c-4.17-2-8.22-4.21-12.21-6.55l-.58-.34c-4.13-2.43-8.18-5-12.22-7.6l-.57-.37c-.91-.59-1.81-1.18-2.73-1.76-9.18-5.91-18.3-12-28.15-16.74a61.68,61.68,0,0,0-15.4-5.28,33,33,0,0,0-8.12-.45c-.68.05-1.34.14-2,.23-.46.09-.92.15-1.39.25.07-.17.13-.32.21-.48l1.12-.22c.68-.08,1.36-.18,2-.24a34.4,34.4,0,0,1,8.23.44,62.31,62.31,0,0,1,15.54,5.3c9.9,4.74,19,10.83,28.24,16.72.9.57,1.8,1.16,2.71,1.73.19.12.39.26.58.37,4.11,2.63,8.24,5.25,12.45,7.72l.59.34c3.89,2.27,7.86,4.42,11.94,6.36a93.66,93.66,0,0,0,8.74,3.64Zm-11.09-52-.42.4c-7.9,7.7-13.8,17.09-19.37,26.47-1.18,2-2.35,4-3.54,6-.1.17-.19.34-.29.5-1.51,2.54-3,5.08-4.6,7.57-1.39,2.19-2.83,4.35-4.37,6.44-.14.2-.27.39-.42.58a67.41,67.41,0,0,1-5,6,40.34,40.34,0,0,1-6.13,5.33l-.83.59c-.27.19-.58.34-.87.52l-1.75,1a30.49,30.49,0,0,1-3.73,1.59,51,51,0,0,1-16,2.59,74.37,74.37,0,0,1-16.2-1.83c-5.1-1.09-10.1-2.54-15.11-4,0,.17-.08.33-.13.48,5,1.47,10,2.95,15.12,4A75.33,75.33,0,0,0,105.47,366a51.36,51.36,0,0,0,16.21-2.61,29.52,29.52,0,0,0,3.81-1.6l1.8-1a9.77,9.77,0,0,0,.88-.53l.85-.6a39.6,39.6,0,0,0,6.24-5.39,71.34,71.34,0,0,0,5.35-6.44,7,7,0,0,0,.42-.58c1.46-2,2.83-4,4.14-6.1,1.59-2.49,3.11-5,4.61-7.55.11-.17.21-.34.3-.5l3.56-6c5.57-9.37,11.48-18.68,19.29-26.28l.14-.13C173,300.35,172.9,300.07,172.83,299.8Zm5.92,24.34c-.79,1-1.59,2-2.4,3A86.18,86.18,0,0,1,165,338.86c-.82.65-1.64,1.29-2.49,1.9l-.53.38a32,32,0,0,1-3.72,2.25l-.89.48c-.3.17-.63.28-.93.42l-1.87.8a30.86,30.86,0,0,1-3.89,1.12,46.73,46.73,0,0,1-9.67,1h-.79c-1.92,0-3.85-.15-5.77-.36a74,74,0,0,1-15.85-3.8c-5.17-1.77-10.18-3.95-15.2-6.11a132.73,132.73,0,0,0-15.35-5.83c-1.55-.44-3.12-.83-4.72-1.12l-.15.45a46.49,46.49,0,0,1,4.73,1.12,132,132,0,0,1,15.28,5.84c5,2.17,10.05,4.36,15.22,6.16a75.72,75.72,0,0,0,16,3.86c1.8.2,3.61.34,5.41.37.27,0,.52,0,.79,0a46.84,46.84,0,0,0,10.22-1,35.23,35.23,0,0,0,4-1.13l1.9-.82c.32-.15.64-.26.94-.42l.92-.5a29.46,29.46,0,0,0,4-2.45c.18-.12.36-.24.54-.38.78-.56,1.54-1.15,2.3-1.76a85.06,85.06,0,0,0,11.44-11.8c.7-.84,1.38-1.7,2.06-2.56C178.87,324.71,178.81,324.42,178.75,324.14Zm-12.88-45.35c-.71.18-1.43.34-2.15.49l-2,.39c-.66.12-1.34.16-2,.25l-2,.24-2,.08a34.8,34.8,0,0,1-8.1-.43,42.91,42.91,0,0,1-12.05-4l-1-.5c-.71-.37-1.42-.76-2.12-1.16a80.63,80.63,0,0,1-13.14-9.61l-.45.45A83.21,83.21,0,0,0,132,274.74l1.5.83,1,.51a44.73,44.73,0,0,0,12.92,4.42,48.53,48.53,0,0,0,18.71-1ZM158.58,264a95.46,95.46,0,0,1-17.33,9.17,57.14,57.14,0,0,1-6.76,2.16l-1,.25a56.84,56.84,0,0,1-8.1,1.26l-2,.13c-.67.05-1.35,0-2,0h-2l-2-.16a35.24,35.24,0,0,1-7.3-1.22c-.14.19-.29.39-.42.59a50.42,50.42,0,0,0,24.92-.09l1-.26a54.28,54.28,0,0,0,6-2A94.84,94.84,0,0,0,159,264.6Zm30.65,125.57c-1.07,0-2.13.09-3.2.12H186l-.62.05a42.82,42.82,0,0,0-15,4.47,68.41,68.41,0,0,0-9.6,6.07h.64a67.53,67.53,0,0,1,9.15-5.7,42.28,42.28,0,0,1,15.2-4.44l.38,0h.25c1,0,2-.11,3-.1C189.26,389.86,189.25,389.71,189.23,389.56Zm.53,4.71q-1.66-2.11-3.45-4.17c-.11-.14-.24-.27-.36-.41l-.42-.49a61.93,61.93,0,0,0-12.25-10.94,33,33,0,0,0-7.4-3.62c-.64-.22-1.32-.4-2-.59s-1.35-.32-2-.42c-1.36-.25-2.74-.27-4.1-.41a42.43,42.43,0,0,0-16.18,2.58A73.77,73.77,0,0,0,127,383.28c-8.18,5.27-15.67,11.49-23.65,17h.36c7.94-5.42,15.39-11.52,23.49-16.69a73.83,73.83,0,0,1,14.55-7.41,42.25,42.25,0,0,1,16-2.53c1.34.15,2.71.17,4.05.42.67.1,1.32.29,2,.42s1.32.36,2,.58a33.12,33.12,0,0,1,7.29,3.58,61.45,61.45,0,0,1,12.12,10.89l.18.2.35.4c1.44,1.67,2.84,3.37,4.2,5.12C189.84,394.94,189.8,394.62,189.76,394.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3,413.44H166.1c-6.84,0,3.06-19.49,28-27S254.18,406.13,246.3,413.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.83,413.44a25,25,0,0,1,1.17-6.51,27.85,27.85,0,0,1,2.7-6.09,22.42,22.42,0,0,1,4.23-5.17,19.6,19.6,0,0,1,5.59-3.56c-.45.33-.9.65-1.35.95l-.68.46-.62.53-1.26,1-1.14,1.15a27.76,27.76,0,0,0-3.91,5.12,38.78,38.78,0,0,0-2.84,5.83c-.39,1-.75,2-1.05,3.09S215.08,412.37,214.83,413.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.33,394.9a48.89,48.89,0,0,1,6.89,2.88,50,50,0,0,1,6.44,3.84,29.33,29.33,0,0,1,5.58,5,17.48,17.48,0,0,1,2.09,3.16,9.47,9.47,0,0,1,1,3.62,10.51,10.51,0,0,0-1.4-3.38,17.39,17.39,0,0,0-2.23-2.89,38.33,38.33,0,0,0-5.59-4.73c-2-1.44-4.1-2.72-6.22-4-1.07-.63-2.15-1.23-3.24-1.81S225.44,395.48,224.33,394.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.32,271.27C85,300.62,50.77,352.43,64.74,363.89c23,18.84,90,29.7,105.43,31.55,6.65.8,20-42.61,15.51-48.23s-75.35-9.58-75.85-13.93c-.28-2.47,10.49-24,17.42-50.3C135.23,252.6,117.47,263,110.32,271.27Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.06,343.63s20.36-.15,33.67.37c7.43.29,20.12,1.93,25.48,4.64,8,4.06,38.94,26.14,33.75,33.75-4.7,6.89-28.86-15.45-28.86-15.45s26.38,20.39,19.19,27.65S226.16,373,226.16,373s26.63,21.55,18,27.87c-6.5,4.77-29.66-20.16-29.66-20.16s22.76,18.69,16.3,23.88c-7.15,5.74-30-15.93-30-15.93-18.66,10.44-31.82,7.78-41,4.77C157.71,392.68,174.06,343.63,174.06,343.63Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.43,359.31c3.18,2.28,6.42,4.57,9.39,7.13s5.86,5.22,8.58,8a68.23,68.23,0,0,1,9.54,12c-5.38-7.36-15.88-16.68-18.85-19.24s-5.8-5.26-8.77-7.81C229.25,359.35,229.35,359.25,229.43,359.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,369.87c3.94,3.09,8,6,11.78,9.28s8.94,8,12.49,11.49c.27.27,0,.77-.29.51-3.69-3.35-9.16-7.94-12.89-11.26s-7.34-6.77-11.17-9.93C219.85,369.91,219.93,369.82,220,369.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.27,377.48c6.26,4.41,11.71,10,16.91,15.57.26.27-.05.32-.33.05-5.53-5.28-9.82-9.47-16.74-15.41C210,377.6,210.14,377.38,210.27,377.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,341,150,396.33s-85.19-19.21-90.13-35.4,21.76-59.48,45.85-86.45c23.7-26.54,27.2-8.54,21.31,12s-15.56,44.19-14.48,46S174.35,341,174.35,341Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,314c-.06.15-.11.31-.17.47a60.55,60.55,0,0,0-14.92-5.06,33,33,0,0,0-8.12-.45c-.68.05-1.34.14-2,.23s-1.33.21-2,.39c-1.33.29-2.59.8-3.89,1.2a41.94,41.94,0,0,0-13.57,8.42l.65-1.11a41.6,41.6,0,0,1,12.77-7.72c1.31-.41,2.59-.93,3.94-1.22.67-.18,1.35-.27,2-.41s1.36-.18,2-.24a34.4,34.4,0,0,1,8.23.44A61.05,61.05,0,0,1,118,314Zm45.1,27.12-.59-.34c-.79-.46-1.57-.93-2.33-1.39l-1.42-.16c1.07.64,2.14,1.3,3.22,1.93l.58.34c3.06,1.8,6.15,3.52,9.31,5.11l.25-.57C169.08,344.48,166.08,342.83,163.12,341.1Zm-16.64-3.39c-.61,1-1.24,2-1.87,3-1.39,2.19-2.83,4.35-4.37,6.44-.14.2-.27.39-.42.58a67.41,67.41,0,0,1-5,6,40.34,40.34,0,0,1-6.13,5.33l-.83.59c-.27.19-.58.34-.87.52l-1.75,1a30.49,30.49,0,0,1-3.73,1.59,51,51,0,0,1-16,2.59,74.37,74.37,0,0,1-16.2-1.83c-5.34-1.14-10.58-2.69-15.84-4.21a145.16,145.16,0,0,0-14.15-3.61c0,.16,0,.33,0,.48,4.74.89,9.39,2.27,14,3.61,5.25,1.54,10.5,3.1,15.86,4.25A75.33,75.33,0,0,0,105.47,366a51.36,51.36,0,0,0,16.21-2.61,29.52,29.52,0,0,0,3.81-1.6l1.8-1a9.77,9.77,0,0,0,.88-.53l.85-.6a39.6,39.6,0,0,0,6.24-5.39,71.34,71.34,0,0,0,5.35-6.44,7,7,0,0,0,.42-.58c1.46-2,2.83-4,4.14-6.1.7-1.08,1.38-2.19,2.05-3.29Zm17.34,2.08c-.42.33-.85.66-1.29,1l-.53.38a32,32,0,0,1-3.72,2.25l-.89.48c-.3.17-.63.28-.93.42l-1.87.8a30.86,30.86,0,0,1-3.89,1.12,46.73,46.73,0,0,1-9.67,1h-.79c-1.92,0-3.85-.15-5.77-.36a74,74,0,0,1-15.85-3.8c-5.17-1.77-10.18-3.95-15.2-6.11a132.73,132.73,0,0,0-15.35-5.83c-5.26-1.5-10.87-2.32-16.31-1.26a19.49,19.49,0,0,0-5,1.73l-.3.63a20,20,0,0,1,5.36-1.93c5.35-1,10.89-.22,16.09,1.28a132,132,0,0,1,15.28,5.84c5,2.17,10.05,4.36,15.22,6.16a75.72,75.72,0,0,0,16,3.86c1.8.2,3.61.34,5.41.37.27,0,.52,0,.79,0a46.84,46.84,0,0,0,10.22-1,35.23,35.23,0,0,0,4-1.13l1.9-.82c.32-.15.64-.26.94-.42l.92-.5a29.46,29.46,0,0,0,4-2.45c.18-.12.36-.24.54-.38.53-.38,1.06-.79,1.6-1.2ZM119.2,264.53c-.44-.39-.87-.77-1.3-1.17l-.55.36,1.43,1.28a86.86,86.86,0,0,0,10.66,8.15c0-.26,0-.51,0-.76A86,86,0,0,1,119.2,264.53Zm6.23,12.3-2,.13c-.67.05-1.35,0-2,0h-2l-2-.16a35.62,35.62,0,0,1-8-1.42c-1.13-.34-2.26-.73-3.37-1.18l-.25.28-.23.27a36.14,36.14,0,0,0,3.66,1.3,48.82,48.82,0,0,0,19.91,1.1c0-.25.07-.5.11-.75C127.91,276.59,126.67,276.73,125.43,276.83Zm32.35,96.39a42.43,42.43,0,0,0-16.18,2.58A73.77,73.77,0,0,0,127,383.28c-2.56,1.66-5.06,3.4-7.53,5.19a3,3,0,0,1,.4.12h0c2.4-1.74,4.83-3.41,7.32-5a73.83,73.83,0,0,1,14.55-7.41,42.25,42.25,0,0,1,16-2.53c.7.08,1.41.12,2.12.18l.19-.43C159.31,373.34,158.54,373.29,157.78,373.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.21,387.19c.83-1.57,1.63-3.16,2.43-4.75q2.42-4.81,4.8-9.67c3.16-6.41,6.13-12.91,9-19.45,1.65-3.71,3.43-7.38,4.92-11.16a.15.15,0,0,0-.28-.13c-1.77,3.13-3.31,6.4-5,9.6s-3.31,6.39-4.9,9.62q-4.71,9.63-9.13,19.4c-.83,1.83-1.74,3.64-2.48,5.5-.39,1-.85,1.87-1.22,2.83s-.67,2-1.07,2.91a.09.09,0,0,0,.16.07C138.39,390.35,139.36,388.81,140.21,387.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.85,392.54l-1.71,3.87-.06.13-.15,0c-8.07-1.5-16.08-3.3-24-5.31S110,387,102.21,384.42a212.6,212.6,0,0,1-23-8.79,85.9,85.9,0,0,1-10.89-5.87,38.31,38.31,0,0,1-4.91-3.8,12.37,12.37,0,0,1-3.52-5,13,13,0,0,0,3.86,4.65A37.49,37.49,0,0,0,68.77,369a102,102,0,0,0,11,5.29c7.53,3.12,15.27,5.79,23,8.29s15.63,4.82,23.5,7.06S142.09,394,150,396.14l-.21.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.4,343.16l.85-2.2.09.15c-8.55-.58-17.08-1.28-25.6-2.17s-17-1.87-25.51-3.14c-2.12-.33-4.24-.67-6.36-1.08-1.07-.22-2.12-.43-3.21-.73-.28-.08-.55-.16-.85-.27a3.88,3.88,0,0,1-.48-.22,2.11,2.11,0,0,1-.34-.22,1.35,1.35,0,0,1-.27-.33,2.56,2.56,0,0,1-.11-.24.19.19,0,0,1,0-.12,3.49,3.49,0,0,1,0-1.15c.06-.28.11-.58.17-.84,1.09-4.25,2.46-8.27,3.85-12.33,2.79-8.11,5.81-16.12,9-24.07-2.47,8.2-5,16.37-7.53,24.54-1.21,4.09-2.55,8.19-3.49,12.27-.06.25-.09.49-.14.73a3.47,3.47,0,0,1,0,.44s0,0,0,0a.52.52,0,0,0-.06-.16.57.57,0,0,0-.14-.17s0,0,0,0a1.61,1.61,0,0,0,.25.1,7.06,7.06,0,0,0,.69.22c1,.26,2,.47,3,.66,2.08.39,4.19.72,6.3,1q6.33,1,12.69,1.79l12.71,1.72c8.48,1.12,17,2.32,25.43,3.55l.15,0-.06.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59,299.48a22,22,0,0,1-2.27,4.09,16.44,16.44,0,0,1-3.11,3.5c.78-1.36,1.61-2.65,2.49-3.93A32.24,32.24,0,0,1,125.59,299.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.41,280.56c-7.22,2.05-20.26-8.54-25.63-17.36-.36-.61,1.09-25.54.87-30.5-.05-1,31.51,6.16,31.51,6.16s-2.6,10.55-2.15,19.21C155.05,258.8,157.4,278.56,150.41,280.56Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.21,248.3c14.75,10.42,29.12,6.42,29.77,6.23a86.26,86.26,0,0,1,2.18-15.67s-31.56-7.19-31.51-6.17C125.75,235,125.49,241.76,125.21,248.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,218.32c.81,7.36,6.7,12.74,13.15,12s11-7.24,10.22-14.6-6.7-12.74-13.15-12S156.2,211,157,218.32Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.28,219.2c.9,8.18,7.45,14.18,14.62,13.39s12.27-8.06,11.37-16.25-7.45-14.17-14.62-13.38S152.38,211,153.28,219.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.29,195.25c-3.44,11.05,2.2,43,10,50.21,11.34,10.4,30,11.5,38.87-2.16,8.59-13.24.49-54.8-8.26-61.33C149,172.36,126.38,178.94,121.29,195.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.88,215.34c0-.08-.15.13-.13.22.48,2.14.67,4.66-1.14,5.75-.05,0,0,.14,0,.12C149,220.64,148.68,217.29,147.88,215.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,213.46c-3.51.4-2.45,7.39.8,7S148.47,213.13,145.53,213.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.32,213.66c0-.08.18.08.19.17.26,2.17.92,4.62,3,5,.06,0,.07.12,0,.12C161.06,219,160.21,215.76,160.32,213.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.91,211.11c3.44-.79,4.76,6.15,1.58,6.88S159,211.77,161.91,211.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.29,210.69a26.12,26.12,0,0,0,2.56-1.37,4.66,4.66,0,0,0,2.35-1.88,1.49,1.49,0,0,0-.51-1.75,3.69,3.69,0,0,0-3.75.18,5.41,5.41,0,0,0-2.74,2.79A1.59,1.59,0,0,0,142.29,210.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.08,207.18a25.26,25.26,0,0,1-2.89-.3,4.62,4.62,0,0,1-2.88-.86,1.49,1.49,0,0,1-.19-1.82,3.69,3.69,0,0,1,3.54-1.24,5.46,5.46,0,0,1,3.6,1.56A1.59,1.59,0,0,1,164.08,207.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06,235.62c.6.43,1.22,1,2,1a5.79,5.79,0,0,0,2.24-.89.08.08,0,0,1,.11.1,3,3,0,0,1-2.57,1.59,2.35,2.35,0,0,1-2-1.66C148.82,235.63,149,235.56,149.06,235.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.36,228.8a7.44,7.44,0,0,0,5.41,2.53,8.93,8.93,0,0,0,2.67-.28,2.83,2.83,0,0,0,.5-.13,3.49,3.49,0,0,0,.46-.15.54.54,0,0,0,.36-.55h0a1.8,1.8,0,0,0-.06-.22v0l0-.19c-.21-1.67-.75-4.18-.75-4.18.65.22,4,1.14,3.79.28-1.52-7.14-3.21-15.08-6.23-21.86a.2.2,0,0,0-.39.11c1.19,6.92,3.59,13.59,4.89,20.52a12.92,12.92,0,0,0-3.64-.53c-.22.1,1.14,4.83,1.18,5.59a.45.45,0,0,1,0,.08c-2.74.78-5,.25-8-1.22C150.35,228.47,150.2,228.65,150.36,228.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.33,230.36a8.92,8.92,0,0,1-3.09,3.24,4,4,0,0,1-2.37.51c-1.79-.19-2.07-1.77-2-3.18a9.64,9.64,0,0,1,.46-2.19A11.45,11.45,0,0,0,157.33,230.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24,233.6a4,4,0,0,1-2.37.51c-1.79-.19-2.07-1.77-2-3.18C151.79,230.84,153.81,231.82,154.24,233.6Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54,206.62c-1.26,3.17-3.85,10.63-5.33,11.15-1.4-10.37-1.45-19.78,1.12-25.55a21.51,21.51,0,0,1,4.4-6.41C127,188.58,127.89,203.29,126.54,206.62Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27,191.79a10.29,10.29,0,0,1-8.63,5.09,10.51,10.51,0,0,1-9-4.73c-.05-.1-.19,0-.14.08a10.38,10.38,0,0,0,9.2,5.48,10.59,10.59,0,0,0,8.84-5.8A.13.13,0,0,0,154.27,191.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.64,175.29a13.1,13.1,0,0,0-6.76-6c-4-1.58-8-.52-12,.61a.09.09,0,0,0,.05.17c3.37-1,6.85-1.73,10.3-.68a13,13,0,0,1,7,5.13,12.59,12.59,0,0,1-2.37,16.31,12.77,12.77,0,0,1-9.74,2.79c-.14,0-.2.19-.06.21a12.85,12.85,0,0,0,13.55-18.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.36,201.63s-7.41-9.51-3.82-16.4c2-3.91,10.87-5,10.87-5s2.07-4.52,9-7.44,16.38-1.22,16.38-1.22,6.26-5.2,13.43-2.61c10,3.6,11.29,17.65,2.91,23.7-5.88,4.25-15.59.09-15.59.09-.82.26-8.51,6.94-16.34.41,0,0-4.46,5.61-9.78,3.15A7.75,7.75,0,0,1,120.36,201.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,221.34s-7.37-10.23-12-7.59,1,17.54,6.52,19.51a5.59,5.59,0,0,0,7.46-3.11Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.66,218c-.09,0-.1.12,0,.15,3.88,1.51,6,5.06,7.43,8.75-1.16-1.41-2.74-2.17-4.63-.78-.1.07,0,.23.11.2a3.44,3.44,0,0,1,3.8,1.15,16.83,16.83,0,0,1,1.86,3c.19.34.81.15.67-.25l0-.08C126.88,225.23,123,218.4,117.66,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83,214.11s-4-15.88-.88-25.61c3.45-10.82,16.47-21.41,31.87-16.92,0,0-17.09,2.21-25.39,16.48-3.81,6.56-.15,25.51-.15,25.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36,219.51c1.57,8.18-3,15.92-10.15,17.3s-14.27-4.15-15.83-12.32,3-15.93,10.15-17.3S136.8,211.33,138.36,219.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.49,219.77c1.41,7.35-2.68,14.31-9.13,15.55s-12.82-3.72-14.23-11.08,2.68-14.31,9.13-15.54S133.08,212.42,134.49,219.77Z",
    style: {
      fill: "#3CC09F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Microphone--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.12,
    y: 249.6,
    width: 41.91,
    height: 1.62,
    transform: "translate(-46.03 438.7) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.77,271.08a8.93,8.93,0,0,1-2.59-.38l-14.08-4.29.88-2.87,14.07,4.29a5.91,5.91,0,0,0,7.37-3.93l5.25-17.24a5.91,5.91,0,0,0-3.93-7.37L273.67,235l.87-2.87,14.08,4.28a8.92,8.92,0,0,1,5.92,11.11l-5.25,17.24A8.92,8.92,0,0,1,280.77,271.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.87,
    y: 268.22,
    width: 3.25,
    height: 7.6,
    transform: "translate(-71.36 447.71) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.97,
    y: 225.22,
    width: 3.25,
    height: 7.6,
    transform: "translate(-20.94 429.76) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.76,
    y: 252.11,
    width: 3,
    height: 7.08,
    transform: "translate(-38.83 458.88) rotate(-73.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.32,238.16l-6.2,20.34-28-8.52a10.62,10.62,0,0,1-7.07-13.26h0a10.63,10.63,0,0,1,13.26-7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.69,238.9h25.06a0,0,0,0,1,0,0v19.81a4.54,4.54,0,0,1-4.54,4.54h-16a4.54,4.54,0,0,1-4.54-4.54V238.9A0,0,0,0,1,262.69,238.9Z",
    transform: "translate(-45.13 441.22) rotate(-73.06)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.69,
    y: 247.62,
    width: 25.06,
    height: 1.42,
    transform: "translate(-48.89 430.66) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.11,
    y: 248.35,
    width: 25.06,
    height: 1.42,
    transform: "translate(-47.88 433.5) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.14,
    y: 252.54,
    width: 2.36,
    height: 11.58,
    transform: "translate(-52.02 446.45) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.48,
    y: 248.13,
    width: 2.36,
    height: 11.58,
    transform: "translate(-46.84 444.6) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 243.71,
    width: 2.36,
    height: 11.58,
    transform: "translate(-41.67 442.76) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 239.3,
    width: 2.36,
    height: 11.58,
    transform: "translate(-36.5 440.91) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.09 400.04 414.1 399.88 431.19 291.01 355.82 229.47 295.12 262.17 294.64 261.29 355.94 228.27 432.27 290.6 432.23 290.88 415.09 400.04",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.43 400.04 418.44 399.88 435.82 289.16 355.82 224.64 297.58 255.88 297.11 255 355.93 223.45 436.9 288.75 436.85 289.03 419.43 400.04",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,258.46a4,4,0,1,1-4.05-4A4.05,4.05,0,0,1,299.64,258.46Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "437.49 400.92 399.52 400.92 402.41 391.65 434.6 391.65 437.49 400.92",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.65,234.85h0a2.87,2.87,0,0,1-2.87-2.87V221.56a2.86,2.86,0,0,1,2.87-2.86h0a2.86,2.86,0,0,1,2.86,2.86V232A2.87,2.87,0,0,1,355.65,234.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.73,292.34h0a2.87,2.87,0,0,1,1.92-3.58l10-3a2.87,2.87,0,0,1,3.57,1.91h0a2.86,2.86,0,0,1-1.91,3.58l-10,3A2.88,2.88,0,0,1,425.73,292.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.7,226.77a4.06,4.06,0,1,1-4.05-4.05A4.05,4.05,0,0,1,359.7,226.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.52,290a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,437.52,290Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 266.84,
    y: 393.72,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.98,
    y: 393.38,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.12,
    y: 393.04,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.26,
    y: 392.7,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.39,
    y: 392.37,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.53,
    y: 392.03,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.67,
    y: 391.69,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.8,
    y: 391.36,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.94,
    y: 391.02,
    width: 7.82,
    height: 5.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.67 401.75 264.93 401.75 264.93 395.55 357.67 392.96 357.67 401.75",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.55 377.44 287.08 377.44 310.05 269.89 454.52 269.89 431.55 377.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.89 377.44 292.42 377.44 315.4 269.89 459.87 269.89 436.89 377.44",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 379.7,
    cy: 317.44,
    rx: 9.67,
    ry: 8.25,
    transform: "translate(-114.6 341.96) rotate(-42.74)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.03 405.54 324.98 405.54 324.98 400.02 396.03 397.72 396.03 405.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.35 405.53 377.2 405.53 354.23 345.26 392.38 345.26 415.35 405.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.63 405.53 383.48 405.53 360.5 345.26 398.65 345.26 421.63 405.53",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.11,500h-1a35.53,35.53,0,0,0-3.52-6.08c-.42-.52-.8-1.07-1.27-1.55L107,490.84a17.19,17.19,0,0,1-2.45-3.52,19.8,19.8,0,0,1-2-8.28,22.56,22.56,0,0,1,.3-4.26,18.68,18.68,0,0,1,1.14-4.12c.56-1.39,1.26-2.5,1.78-3.74s1-2.5,1.52-3.77c.91-2.56,1.69-5.18,2.39-7.83l1.1-4c.37-1.33.76-2.65,1.26-3.94-.64,2.68-1.07,5.38-1.57,8.09a76.26,76.26,0,0,1-2,8.06,39.12,39.12,0,0,1-1.41,3.93c-.5,1.3-1.22,2.56-1.66,3.74a20.25,20.25,0,0,0-1.23,7.76,18.41,18.41,0,0,0,1.79,7.63,16.06,16.06,0,0,0,2.15,3.27l1.33,1.58c.47.54.85,1.14,1.27,1.7A32.77,32.77,0,0,1,114.11,500Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.53,
    y: 369.07,
    width: 138.08,
    height: 88.64,
    transform: "translate(365.15 826.79) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.14,
    y: 382.12,
    width: 100.05,
    height: 65.9,
    transform: "translate(340.33 830.14) rotate(180)",
    style: {
      fill: "#37474f",
      opacity: 0.5700000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.06,
    y: 385.29,
    width: 94.22,
    height: 59.55,
    transform: "translate(340.33 830.14) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,430.6l-2.65,0h-1.5l-1.49,0h-.06v.06c0,.43,0,.86,0,1.28l0,1.25,0-1.28c0-.4,0-.79,0-1.19h-.06l.06-.06v.06l1.39,0h4.42v-.11l.12.11h-.12l0,2.32h.1l-.1.1v-.1h-1.38l-1.49,0-.77,0h-1.18l-1.07,0,1.07,0h1.9l1.5,0h1.61v-.1l0-2.53v-.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.67,433.79l-3,0h-1.37l-1.62,0h-.06v.06c0,.43,0,.86,0,1.28l0,1.25,0-1.28,0-1.19h-.06l.06-.06V434l1.52,0,1.18,0h3.11v-.11l.11.11h-.11l0,2.32h.08l-.08.1v-.1h-1.4l-1.48,0-.77,0-1.18,0h0l-1.06,0,1.06,0,1.17,0h.74l1.5,0h1.61v-2.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.02,
    y: 433.91,
    width: 5.99,
    height: 2.53,
    transform: "translate(414.02 870.34) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,393.08h-3c-1,0-2,0-3,0h-.06v.06c0,.43,0,.85,0,1.27l0,1.26,0-1.28,0-1.19h-.06l.06-.06v.06c1,0,1.95,0,2.93,0l2.88,0v-.11l.11.11h-.11v2.32h.1l-.1.1v-.1h-1.5l-1.37,0-3,.07,3,.06H151v-2.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.21,
    y: 396.38,
    width: 5.99,
    height: 2.53,
    transform: "translate(302.41 795.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.51,396.27h-3c-1,0-2,0-3,0h-.06v.06c0,.43,0,.85,0,1.27l0,.68v0l0-.69c0-.4,0-.8,0-1.19h-.06l.06-.06v.06c.94,0,1.86,0,2.8,0,0,0,0,0,0,0h.21l2.31,0h.48v-.11l.11.11h-.11v2.32h.1l-.1.1v-.1H146l-1.48,0-1,0h-.32l-1.3,0h0l1.23,0h.33l1,0,1.5,0h1.61v-2.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.88,
    y: 433.91,
    width: 5.99,
    height: 2.53,
    transform: "translate(259.74 870.34) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.02,
    y: 402.73,
    width: 5.98,
    height: 2.53,
    transform: "translate(404.03 807.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.14,
    y: 429.38,
    width: 5.99,
    height: 2.53,
    transform: "translate(352.27 861.3) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.63,
    y: 385.29,
    width: 74.95,
    height: 37.42,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.66,
    y: 385.29,
    width: 0.88,
    height: 37.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.58,393.25a1.35,1.35,0,1,1-1.35-1.35A1.34,1.34,0,0,1,189.58,393.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,390.28a3,3,0,0,0-.92,5.79v-.76a2.27,2.27,0,1,1,1.85,0v.76a3,3,0,0,0-.93-5.79Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,389.06a4.19,4.19,0,0,0-1.22,8.19l.25-.67a3.48,3.48,0,1,1,1.95,0l.25.67a4.19,4.19,0,0,0-1.23-8.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,387.69a5.56,5.56,0,0,0-1.69,10.85l.24-.66a4.87,4.87,0,1,1,2.91,0l.24.66a5.56,5.56,0,0,0-1.7-10.85Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.32,387.13a6.78,6.78,0,0,0-6.2,0,6.85,6.85,0,0,0,1,12.64l.23-.66a6.16,6.16,0,0,1,1.15-12,6.3,6.3,0,0,1,.75-.05,6.17,6.17,0,0,1,1.91,12l.24.66a6.85,6.85,0,0,0,.95-12.64Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.88,
    y: 393.36,
    width: 0.71,
    height: 29.85,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.87,
    y: 409.58,
    width: 27.96,
    height: 0.71,
    transform: "translate(-263.04 456.18) rotate(-71.75)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.26,
    y: 395.95,
    width: 0.71,
    height: 27.96,
    transform: "translate(-118.71 80.96) rotate(-18.25)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.1,
    y: 402.88,
    width: 4.27,
    height: 0.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.82,
    y: 406.95,
    width: 6.84,
    height: 0.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.53,
    y: 410.87,
    width: 9.42,
    height: 0.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.77,
    y: 415.88,
    width: 12.94,
    height: 0.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.55,
    y: 413.38,
    width: 11.94,
    height: 0.71,
    transform: "translate(-156.17 116.73) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.6,
    y: 407.76,
    width: 0.71,
    height: 11.94,
    transform: "translate(-265.88 411.81) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.09,
    y: 419.36,
    width: 16.35,
    height: 0.71,
    transform: "translate(-158.7 117.17) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.86,
    y: 411.53,
    width: 0.71,
    height: 16.35,
    transform: "translate(-271.16 415.53) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.33,
    y: 409.11,
    width: 8.77,
    height: 0.71,
    transform: "translate(-154.37 116.42) rotate(-24.79)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.41,
    y: 405.08,
    width: 0.71,
    height: 8.77,
    transform: "translate(-262.12 409.16) rotate(-65.21)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.63,
    y: 404.8,
    width: 6.46,
    height: 0.71,
    transform: "translate(-170 137.99) rotate(-28.38)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.26,
    y: 401.92,
    width: 0.71,
    height: 6.46,
    transform: "translate(-257.49 378.49) rotate(-61.62)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.1,422.7h0l.44.87h9.93c.31-.31.62-.59,1-.87H149.1Zm58.49-37.41V422.7h-75V385.29h-.88v38.29h76.71V385.29ZM148.11,422.7h0l.3.87h11.05c.31-.31.62-.59,1-.87H148.11Zm18.8,0h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.43,
    y: 385.29,
    width: 0.22,
    height: 9.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.93 395.37 206.15 395.37 206.35 394.25 206.74 394.25 206.93 395.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.22,
    y: 385.29,
    width: 0.22,
    height: 19.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.72 405.59 206.94 405.59 207.14 404.47 207.53 404.47 207.72 405.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,439c0-.1,0-.21-.05-.33s0-.11,0-.17h0a14.17,14.17,0,0,0-.4-1.65c-.05-.18-.1-.37-.16-.57s-.11-.37-.17-.56-.11-.32-.16-.49-.18-.53-.27-.81l-.06-.18c0-.13-.09-.27-.14-.4s-.1-.3-.16-.46a.16.16,0,0,0,0-.08.25.25,0,0,0,0-.07l-.16-.45s0-.09-.05-.15c-.5-1.42-1.06-2.93-1.6-4.38l-.06-.18h0a.13.13,0,0,1,0-.07c-.6-1.6-1.16-3.11-1.61-4.36v0h0l-.3-.87h0l-.06-.18c-.06-.16-.11-.32-.15-.46-.1-.31-.19-.57-.25-.8a4.37,4.37,0,0,1-.12-.51.59.59,0,0,1,0-.17,1.29,1.29,0,0,1,.08-.39v-.06l0-.05,0,0a.45.45,0,0,1,0-.11s0,0,0-.06a1.3,1.3,0,0,1,.08-.17h0c0-.1.08-.2.12-.31h0a1.42,1.42,0,0,1,.08-.18h0s0,0,0,0l.14-.3.66-1.44c0-.05,0-.11.07-.17h0A2.56,2.56,0,0,0,149,417v0h0l0-.08a1.17,1.17,0,0,1,.1-.26l0-.11a.54.54,0,0,0,.05-.11v0l0,0c0-.11.09-.22.13-.32h0l.06-.16s0,0,0,0,0-.08,0-.11v0c.09-.23.16-.45.23-.67h0c0-.09.06-.17.08-.25a1.8,1.8,0,0,0,.06-.22v0l.06-.24A2.39,2.39,0,0,0,150,414a.57.57,0,0,0,0-.18,2.2,2.2,0,0,0,0-.51,2.11,2.11,0,0,0,0-.26,1.57,1.57,0,0,0-.08-.31,2.29,2.29,0,0,0-.31-.57l-.2-.24h0l-.24-.24a.39.39,0,0,0-.1-.08l-.44-.38c-.16-.13-.32-.25-.5-.37a2.48,2.48,0,0,0-.26-.19l-.14-.09-.27-.17h0a.57.57,0,0,0-.13-.08l-.51-.31-1.22-.69-.47-.27h0l-.58-.31-.13-.08h0l0,0-.05,0-.23-.12-.32-.18-.09-.06-.05,0-.16-.09-.12-.08-.29-.22,0,0a1,1,0,0,1-.13-.19,2,2,0,0,1-.12-.25.2.2,0,0,1,0-.08l-.06-.16c-.11-.3-.22-.67-.34-1.09,0-.15-.09-.3-.13-.46h0a.57.57,0,0,1,0-.14c-.11-.38-.22-.78-.35-1.19h0c0-.07,0-.15-.07-.23s-.13-.4-.21-.6v0h0s0,0,0,0v0c0-.08-.06-.16-.08-.23s0-.15-.08-.22h0c0-.09-.07-.18-.11-.26a.32.32,0,0,0,0-.09c-.05-.1-.09-.21-.14-.31a.91.91,0,0,0-.07-.14c-.07-.17-.17-.35-.26-.52a1.09,1.09,0,0,1-.08-.15l-.1-.16-.06-.1-.06-.08a1.63,1.63,0,0,0-.11-.17l-.21-.28a1.27,1.27,0,0,0-.37-.3l-.17-.09a3,3,0,0,0-.4-.16l-.28-.08-.31-.07a6.86,6.86,0,0,0-.68-.12l-.75-.07h-.39c-.39,0-.78,0-1.17,0l-.64.06c-.37,0-.74.1-1.08.17a.86.86,0,0,0-.17,0l-.47.13-.15,0-.08,0-.06,0h0l-.14.05-.08,0-.16.07-.15.08-.07,0-.16.09-.22.16-.12.09h0a1.45,1.45,0,0,0-.21.22,9.34,9.34,0,0,0-.85,1.62l-.21.5-.44,1.08c0,.09-.07.18-.1.28a1.48,1.48,0,0,0-.1.27.61.61,0,0,0-.07.14,1.21,1.21,0,0,1-.05.14c0,.06-.05.12-.08.19l-.38,1s0,.08,0,.12a1.6,1.6,0,0,1-.1.23,3,3,0,0,1-.12.32c0,.05,0,.09-.05.13l-.14.34c0,.08-.07.16-.1.23a.21.21,0,0,0,0,.06l0,.06a1.07,1.07,0,0,1-.07.15l0,0-.05.07h0a7.38,7.38,0,0,1-.59.61l-.22.22a2.77,2.77,0,0,0-.25.24c-.09.1-.2.2-.31.3l-.32.32c-.32.32-.64.66-.94,1l-.15.17-.14.18-.14.17-.13.18c-.13.18-.25.35-.35.52a1.49,1.49,0,0,0-.14.24l-.13.26c0,.06-.06.14-.09.22a.15.15,0,0,1,0,.09,1,1,0,0,0-.06.25,1.55,1.55,0,0,0-.05.23,4.77,4.77,0,0,0-.09.6,1.87,1.87,0,0,0,0,.34c0,.29,0,.61-.07.95s0,.71,0,1.1c0,1.29,0,2.81.1,4.47v0h0c.21,4.53.68,10.09,1,14.84.25,4.09.23,7.45.19,9.38h23l1.3.22c0-.07.05-.14.08-.22h1.87c.1-.17.19-.35.29-.53l.24-.49c.18-.38.36-.77.52-1.18.05-.1.08-.2.12-.3l.12-.3h0l.09-.27v0a.46.46,0,0,1,0-.09l.18-.59.09-.43a1.88,1.88,0,0,0,.06-.31.77.77,0,0,0,0-.15c0-.13,0-.25.05-.37a.86.86,0,0,0,0-.16.1.1,0,0,0,0-.07h0V439ZM138.45,402.1c.51.27,1.08,1.93,1.35,3.31h0l.06.34c.14.82.14,1.47-.08,1.56l-.12,0-.26.05a2.25,2.25,0,0,1-1.93-.59C137.15,406.26,137.56,401.62,138.45,402.1Zm-2.91,5.12a2.33,2.33,0,0,1-2.3.5c-.61-.25.46-4.76,1.32-5.22S135.86,406.65,135.54,407.22Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,439c0-.1,0-.21-.05-.33s0-.11,0-.17h0a14.17,14.17,0,0,0-.4-1.65c-.05-.18-.1-.37-.16-.57s-.11-.37-.17-.56-.11-.32-.16-.49-.18-.53-.27-.81l-.06-.18c0-.13-.09-.27-.14-.4s-.1-.3-.16-.46a.16.16,0,0,0,0-.08.25.25,0,0,0,0-.07l-.16-.45s0-.09-.05-.15c-.5-1.42-1.06-2.93-1.6-4.38l-.06-.18h0a.13.13,0,0,1,0-.07c-.6-1.6-1.16-3.11-1.61-4.36v0h0l-.3-.87h0l-.06-.18c-.06-.16-.11-.32-.15-.46-.1-.31-.19-.57-.25-.8a4.37,4.37,0,0,1-.12-.51.59.59,0,0,1,0-.17,1.29,1.29,0,0,1,.08-.39v-.06l0-.05,0,0a.45.45,0,0,1,0-.11s0,0,0-.06a1.3,1.3,0,0,1,.08-.17h0c0-.1.08-.2.12-.31h0a1.42,1.42,0,0,1,.08-.18h0s0,0,0,0l.14-.3.66-1.44c0-.05,0-.11.07-.17h0A2.56,2.56,0,0,0,149,417v0h0l0-.08a1.17,1.17,0,0,1,.1-.26l0-.11a.54.54,0,0,0,.05-.11v0l0,0c0-.11.09-.22.13-.32h0l.06-.16s0,0,0,0,0-.08,0-.11v0c.09-.23.16-.45.23-.67h0c0-.09.06-.17.08-.25a1.8,1.8,0,0,0,.06-.22v0l.06-.24A2.39,2.39,0,0,0,150,414a.57.57,0,0,0,0-.18,2.2,2.2,0,0,0,0-.51,2.11,2.11,0,0,0,0-.26,1.57,1.57,0,0,0-.08-.31,2.29,2.29,0,0,0-.31-.57l-.2-.24h0l-.24-.24a.39.39,0,0,0-.1-.08l-.44-.38c-.16-.13-.32-.25-.5-.37a2.48,2.48,0,0,0-.26-.19l-.14-.09-.27-.17h0a.57.57,0,0,0-.13-.08l-.51-.31-1.22-.69-.47-.27h0l-.58-.31-.13-.08h0l0,0-.05,0-.23-.12-.32-.18-.09-.06-.05,0-.16-.09-.12-.08-.29-.22,0,0a1,1,0,0,1-.13-.19,2,2,0,0,1-.12-.25.2.2,0,0,1,0-.08l-.06-.16c-.11-.3-.22-.67-.34-1.09,0-.15-.09-.3-.13-.46h0a.57.57,0,0,1,0-.14c-.11-.38-.22-.78-.35-1.19h0c0-.07,0-.15-.07-.23s-.13-.4-.21-.6v0h0s0,0,0,0v0c0-.08-.06-.16-.08-.23s0-.15-.08-.22h0c0-.09-.07-.18-.11-.26a.32.32,0,0,0,0-.09c-.05-.1-.09-.21-.14-.31a.91.91,0,0,0-.07-.14c-.07-.17-.17-.35-.26-.52a1.09,1.09,0,0,1-.08-.15l-.1-.16-.06-.1-.06-.08a1.63,1.63,0,0,0-.11-.17l-.21-.28a1.27,1.27,0,0,0-.37-.3l-.17-.09a3,3,0,0,0-.4-.16l-.28-.08-.31-.07a6.86,6.86,0,0,0-.68-.12l-.75-.07h-.39c-.39,0-.78,0-1.17,0l-.64.06c-.37,0-.74.1-1.08.17a.86.86,0,0,0-.17,0l-.47.13-.15,0-.08,0-.06,0h0l-.14.05-.08,0-.16.07-.15.08-.07,0-.16.09-.22.16-.12.09h0a1.45,1.45,0,0,0-.21.22,9.34,9.34,0,0,0-.85,1.62l-.21.5-.44,1.08c0,.09-.07.18-.1.28a1.48,1.48,0,0,0-.1.27.61.61,0,0,0-.07.14,1.21,1.21,0,0,1-.05.14c0,.06-.05.12-.08.19l-.38,1s0,.08,0,.12a1.6,1.6,0,0,1-.1.23,3,3,0,0,1-.12.32c0,.05,0,.09-.05.13l-.14.34c0,.08-.07.16-.1.23a.21.21,0,0,0,0,.06l0,.06a1.07,1.07,0,0,1-.07.15l0,0-.05.07h0a7.38,7.38,0,0,1-.59.61l-.22.22a2.77,2.77,0,0,0-.25.24c-.09.1-.2.2-.31.3l-.32.32c-.32.32-.64.66-.94,1l-.15.17-.14.18-.14.17-.13.18c-.13.18-.25.35-.35.52a1.49,1.49,0,0,0-.14.24l-.13.26c0,.06-.06.14-.09.22a.15.15,0,0,1,0,.09,1,1,0,0,0-.06.25,1.55,1.55,0,0,0-.05.23,4.77,4.77,0,0,0-.09.6,1.87,1.87,0,0,0,0,.34c0,.29,0,.61-.07.95s0,.71,0,1.1c0,1.29,0,2.81.1,4.47v0h0c.21,4.53.68,10.09,1,14.84.25,4.09.23,7.45.19,9.38h23l1.3.22c0-.07.05-.14.08-.22h1.87c.1-.17.19-.35.29-.53l.24-.49c.18-.38.36-.77.52-1.18.05-.1.08-.2.12-.3l.12-.3h0l.09-.27v0a.46.46,0,0,1,0-.09l.18-.59.09-.43a1.88,1.88,0,0,0,.06-.31.77.77,0,0,0,0-.15c0-.13,0-.25.05-.37a.86.86,0,0,0,0-.16.1.1,0,0,0,0-.07h0V439ZM138.45,402.1c.51.27,1.08,1.93,1.35,3.31h0l.06.34c.14.82.14,1.47-.08,1.56l-.12,0-.26.05a2.25,2.25,0,0,1-1.93-.59C137.15,406.26,137.56,401.62,138.45,402.1Zm-2.91,5.12a2.33,2.33,0,0,1-2.3.5c-.61-.25.46-4.76,1.32-5.22S135.86,406.65,135.54,407.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.59,439.28v.28h0a1.6,1.6,0,0,1,0,.23,4.63,4.63,0,0,1-.07.52,1.88,1.88,0,0,1-.06.31l-.09.43-.18.59a.46.46,0,0,0,0,.09v0l-.1.27h0q-.1.3-.24.6c-.16.41-.34.8-.52,1.18l-.24.49c-.1.18-.19.36-.29.53h-1.87a26.44,26.44,0,0,0,1.13-4,.29.29,0,0,0,0-.09,6.07,6.07,0,0,0,.1-1.06,3.78,3.78,0,0,0-.11-.81c-.17-.88-.56-2.23-1-3.8a2,2,0,0,1-.08-.26c-.06-.19-.13-.39-.19-.59l0-.13c-.06-.2-.13-.41-.2-.62l-.1-.31a1.09,1.09,0,0,0,0-.17.74.74,0,0,1,0-.14,1.31,1.31,0,0,1-.09-.28.82.82,0,0,1-.06-.19h0c-.17-.52-.34-1.06-.51-1.6l-.07-.18h0c-.82-2.51-1.65-5.05-2.2-7-.09-.31-.17-.6-.23-.87h0a8.68,8.68,0,0,1-.41-2.09,3.1,3.1,0,0,1,.17-1l0-.08a.25.25,0,0,1,0-.07,6.82,6.82,0,0,1,.44-1,1.27,1.27,0,0,1,.12-.23c.61-1.11,1.43-2.25,1.94-3.28a4.51,4.51,0,0,0,.25-.57,3.16,3.16,0,0,0,.12-.37,2.06,2.06,0,0,0,.09-.87c-.16-1.22-2.15-2.38-3.91-3.33h0l-.34-.18-.68-.36-.4-.22-.61-.37a3.17,3.17,0,0,1-.52-.39,1.62,1.62,0,0,1-.29-.42,1.23,1.23,0,0,1-.12-.26,7.22,7.22,0,0,1-.33-.85h0c0-.1-.07-.21-.1-.32-.11-.37-.22-.78-.33-1.19l-.24-.93s0,0,0-.06c-.43-1.69-.85-3.31-1.3-3.67-.91-.72-6-.68-7,.83l0,.06a11.73,11.73,0,0,0-.84,2.19c-.56,1.85-1.08,4.13-1.59,5.22-.75,1.61-4.11,2.67-4.22,5.34-.08,1.73,2.55,9.62,4.17,16.12,0,.23.11.46.16.68h0a.29.29,0,0,0,0,.09c.23,1,.43,1.88.6,2.74a23.67,23.67,0,0,1,.38,2.53c0,.31.06.61.06.88v.35a4.45,4.45,0,0,1-.08.87c-.08.4-.17.78-.26,1.15l-.09.35a.56.56,0,0,1,0,.12l0,.14a18.6,18.6,0,0,1-.8,2.33,19.39,19.39,0,0,1-1,2.21h-1a39.23,39.23,0,0,0,1.62-5.28.29.29,0,0,0,0-.09.36.36,0,0,0,0-.11,3.58,3.58,0,0,0,.08-.43,5.47,5.47,0,0,0,.1-.93,4.44,4.44,0,0,0-.08-.78.5.5,0,0,1,0-.12h0c0-.2-.08-.42-.13-.66-.16-.66-.38-1.46-.64-2.35l-.06-.18c-.05-.17-.11-.35-.16-.53-1.29-4.18-3.37-9.9-4.43-12.76h0v0c-.08-1.66-.12-3.18-.1-4.47,0-.39,0-.76,0-1.1s0-.66.07-.95a1.87,1.87,0,0,1,0-.34,4.77,4.77,0,0,1,.09-.6,1.55,1.55,0,0,1,.05-.23,1,1,0,0,1,.06-.25,2.24,2.24,0,0,1,.11-.31l.13-.26a1.49,1.49,0,0,1,.14-.24c.1-.17.22-.34.35-.52a4.11,4.11,0,0,1,.27-.35c.09-.12.19-.23.29-.35.3-.34.62-.68.94-1l.32-.32c.11-.1.22-.2.31-.3a2.77,2.77,0,0,1,.25-.24l.22-.22a7.38,7.38,0,0,0,.59-.61.19.19,0,0,0,.06-.07l0,0a1.07,1.07,0,0,0,.07-.15l0-.06c.09-.19.2-.45.33-.76a3,3,0,0,0,.12-.32c0-.11.09-.23.14-.35l.38-1,.13-.33a.61.61,0,0,1,.07-.14c.06-.18.13-.37.2-.55l.44-1.08.21-.5a9.34,9.34,0,0,1,.85-1.62,1.45,1.45,0,0,1,.21-.22l.12-.1.22-.16.23-.12.31-.14.22-.09h0l.14-.05.15,0,.64-.16c.34-.07.71-.13,1.08-.17l.64-.06c.39,0,.78,0,1.17,0h.39l.75.07a6.86,6.86,0,0,1,.68.12l.31.07.28.08a3,3,0,0,1,.4.16l.17.09a1.27,1.27,0,0,1,.37.3c.11.14.22.3.32.45s.21.33.3.49.19.35.26.52a4.25,4.25,0,0,1,.24.54c0,.08.07.17.11.26l.09.23c0,.07.05.15.08.23v0h0v0c.08.2.15.41.21.61l.08.23h0c.13.41.24.81.35,1.19a.57.57,0,0,0,0,.14h0c0,.16.09.31.13.46.12.42.23.79.34,1.09a1.73,1.73,0,0,0,.1.24,1.59,1.59,0,0,0,.26.44l0,0,.29.22.12.07h0l.16.09.14.09.32.18.28.15,0,0v0l.14.07.58.31s0,0,0,0l.49.26,1.22.69.51.31a.57.57,0,0,1,.13.08h0l.27.17.4.28c.18.12.34.24.5.37l.44.38a3.51,3.51,0,0,1,.33.34l.21.23a2.29,2.29,0,0,1,.31.57,1.57,1.57,0,0,1,.08.31,2.11,2.11,0,0,1,0,.26,2.2,2.2,0,0,1,0,.51.57.57,0,0,1,0,.18,5.53,5.53,0,0,1-.25,1.1h0c-.07.22-.14.44-.23.67v0s0,.07,0,.11l-.07.16h0c0,.1-.09.21-.13.32s0,0,0,0a.54.54,0,0,1-.05.11s0,.08,0,.12-.08.17-.11.25l0,.08h0a2.56,2.56,0,0,1-.11.24.71.71,0,0,1-.08.18l-.66,1.44c-.05.11-.1.21-.14.31h0a1.42,1.42,0,0,0-.08.18h0c0,.1-.09.2-.13.3h0a1.44,1.44,0,0,0-.09.24,1,1,0,0,1,0,.1s0,0,0,0a.14.14,0,0,0,0,.06.09.09,0,0,0,0,.05,1.29,1.29,0,0,0-.08.39.59.59,0,0,0,0,.17,4.37,4.37,0,0,0,.12.51c.06.23.15.49.25.8,0,.14.1.3.15.46l.06.18h0l.3.87s0,0,0,0c.45,1.25,1,2.76,1.61,4.36l0,.08.06.18c.54,1.45,1.1,3,1.6,4.38,0,.06,0,.11.05.15l.16.45a.25.25,0,0,1,0,.07.16.16,0,0,1,0,.08c.06.16.11.31.16.46s.09.27.13.4h0l.06.18q.14.42.27.81c0,.17.1.33.16.49s.11.38.17.56.11.39.16.57a14.17,14.17,0,0,1,.4,1.65.57.57,0,0,1,0,.18c0,.12,0,.23.05.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.41,420.63c3.14,7,10.73,18.66,14.13,15.78,5.08-4.31,8.51-13.86,9.88-17.71.76-2.17-10.25-5.78-10.92-3.82-1,2.79-2.47,8.62-3.34,9.44-.46.44-4.06-4.63-6.79-7C147.43,413.83,147.41,418.4,148.41,420.63Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,413.25c-.5,2.36-3.41,6.79-4.53,7.59s-8.84-3.68-9-5.08,2.17-9.44,4.07-11S175.52,410.8,175,413.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.67,414.14a20.17,20.17,0,0,0-1.82-5.53c-1.12-2-3-4.95-1.93-5.59,2.21-1.31,6.91,5.94,6.91,5.94s1.56,3.53-.51,5A2.54,2.54,0,0,1,161.67,414.14Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.12,407.75c.42,1.21,1.6,0,1.6,0s-1.29,2.12-.38,3.2,2.27-.45,2.37-.56c-.07.12-1.2,2.1-.17,3.08s2.2-.7,2.27-.81c0,.13-.4,1.8.56,2.38,1.64,1,2.7-3.29,4.06-4,0,0,1.52,2.16,1.58,2.22s1.09-4,0-5.82a1.33,1.33,0,0,0-1.57-.58,2.08,2.08,0,0,0-.29-2.06c-.41-.42-1.43-.13-1.43-.13a1.67,1.67,0,0,0-.39-1.7,1.6,1.6,0,0,0-1.52-.17s-.11-1.15-.9-1.5C167.32,400.58,162.22,405.16,163.12,407.75Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,402.82s0,0,0,0a11.93,11.93,0,0,0-5,5c0,.07.06.15.11.08A24.84,24.84,0,0,1,169.65,402.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.73,404.62s0-.05,0,0a11.12,11.12,0,0,0-5.09,5.83c0,.08,0,.19.07.1A20.14,20.14,0,0,1,171.73,404.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.81,412.88a15.42,15.42,0,0,1,4.53-6s0-.05,0,0a10.07,10.07,0,0,0-3.11,2.78,6.91,6.91,0,0,0-1.46,3.22S168.79,412.93,168.81,412.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.68,407.78c0,.08.12.05.08.13-.15.36-.92,2.57-.25,3.06s1.45-.06,1.73-.37l.7-.77-.39,1a4.27,4.27,0,0,0-.31,1.36,1.52,1.52,0,0,0,.37,1.19.88.88,0,0,0,1.09.18,2.73,2.73,0,0,0,.93-.95l.65-1.06-.27,1.21a3.84,3.84,0,0,0-.09,1,1.56,1.56,0,0,0,.27.92.79.79,0,0,0,.77.32,1.76,1.76,0,0,0,.81-.55A14.13,14.13,0,0,0,172,412.7c.2-.3.4-.6.62-.9a2.57,2.57,0,0,1,.77-.77,2.91,2.91,0,0,0-.69.83c-.19.31-.37.62-.55.94a11.38,11.38,0,0,1-1.2,1.84,2,2,0,0,1-1,.69,1.13,1.13,0,0,1-1.16-.43,2,2,0,0,1-.36-1.13,4.36,4.36,0,0,1,.09-1.14l.38.15a2.93,2.93,0,0,1-1.08,1.13,1.26,1.26,0,0,1-.85.15,1.39,1.39,0,0,1-.75-.41,2,2,0,0,1-.47-1.51,4.73,4.73,0,0,1,.37-1.49l.31.2a2,2,0,0,1-2.24.49C163.19,410.5,164.42,408.18,164.68,407.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.72,407.77a2.7,2.7,0,0,1-.71.34.59.59,0,0,1-.59-.14,1.22,1.22,0,0,1-.26-.63c0-.25-.07-.52-.09-.8a1.9,1.9,0,0,0-.19.82,1.18,1.18,0,0,0,.29.87.83.83,0,0,0,.46.22.92.92,0,0,0,.47-.08A1.39,1.39,0,0,0,164.72,407.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.83,415.09l11.46,8s-6.85,14.19-11.08,14.15S150.87,426.56,148.75,422s-.85-8.48,3.42-4.29,5.79,5.91,5.93,5.85S160.83,415.09,160.83,415.09Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.29,423.07s-4.75,9.84-8.78,13.11a3.92,3.92,0,0,1-2.3,1c-4.23,0-10.34-10.67-12.46-15.26-1.31-2.84-1.32-5.41-.13-6,.73-.34,1.92.08,3.55,1.68,4.28,4.21,5.79,5.91,5.93,5.85s2.73-8.43,2.73-8.43Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.25,416.19h0l-.2.13h0l-.12.07h0l-.27.17-.4.24,0,0L149,417h0c-.17.11-.33.21-.5.3s-.39.22-.59.32a.47.47,0,0,1-.12.07v.18h0l.11-.06c.33-.18.66-.36,1-.55h0l.22-.13.08,0,.07,0h0l.08-.05,0,0,.65-.42h0l.18-.13h0l.22-.14Zm3.26,2.82c-.1,0-.2.09-.3.12a10.11,10.11,0,0,1-1.69.55l-.15,0-.32.07-.44.09c-.15,0-.3,0-.45.06l-.44.05-.45,0-.49,0-.49,0H148l0,.1a.06.06,0,0,0,0,0h.19q.31,0,.63,0a8.44,8.44,0,0,0,.87,0,4.4,4.4,0,0,0,.51-.05c.24,0,.48-.06.72-.11l.49-.1.11,0a11.57,11.57,0,0,0,1.75-.58l.3-.13Zm.41,4.57c-.3.24-.58.49-.86.75h0l-.09.08c-.17.16-.33.33-.49.5a3.31,3.31,0,0,0-.39.45c-.13.13-.24.26-.35.39s-.27.32-.4.49h0l-.21.26.09.15.21-.26h0c.33-.42.67-.82,1-1.21.21-.22.42-.44.64-.65l0,0a10.7,10.7,0,0,1,1.09-.93Zm10.34-3,.29-.12h0l.12,0,.44-.12.43-.12.3-.06.14,0a7.58,7.58,0,0,1,1.78-.19h0l-.2-.15h0a9.77,9.77,0,0,0-1.87.24h0a10.89,10.89,0,0,0-1.27.37h0l-.34.13a11.36,11.36,0,0,0-1.69.8l-.2.11a13,13,0,0,0-1.15.79l-.59.47h0c-.34.28-.65.56-1,.87-.59.56-1.13,1.15-1.68,1.78h0c-.13.17-.27.33-.42.51s-.51.63-.75.95-.36.45-.54.68c-.57.73-1.13,1.47-1.71,2.19h0l-.44.55h0l-.08.09-.17.2h0a1,1,0,0,1,.08.11h0l.19-.23.05-.06a4,4,0,0,0,.26-.32l.14-.19h0c.61-.75,1.19-1.52,1.78-2.28l.51-.65c.19-.24.39-.48.57-.72s.29-.35.43-.52c.64-.74,1.29-1.46,2-2.13.33-.31.66-.6,1-.87h0l.42-.34a11.32,11.32,0,0,1,1.3-.87,4.87,4.87,0,0,1,.52.12A15.84,15.84,0,0,1,166,422.7h.35a18.78,18.78,0,0,0-3.36-1.24l-.37-.08a10,10,0,0,1,1.59-.74Zm-10.34,3c-.3.24-.58.49-.86.75h0l-.09.08c-.17.16-.33.33-.49.5a3.31,3.31,0,0,0-.39.45c-.13.13-.24.26-.35.39s-.27.32-.4.49h0l-.21.26.09.15.21-.26h0c.33-.42.67-.82,1-1.21.21-.22.42-.44.64-.65l0,0a10.7,10.7,0,0,1,1.09-.93Zm0,0c-.3.24-.58.49-.86.75h0l-.09.08c-.17.16-.33.33-.49.5a3.31,3.31,0,0,0-.39.45c-.13.13-.24.26-.35.39s-.27.32-.4.49h0l-.21.26.09.15.21-.26h0c.33-.42.67-.82,1-1.21.21-.22.42-.44.64-.65l0,0a10.7,10.7,0,0,1,1.09-.93Zm16.15,1.18a2.61,2.61,0,0,0-.28-.17c-.5-.31-1-.6-1.52-.89h0l-.2-.11c-.54-.3-1.1-.59-1.66-.86h0a18.78,18.78,0,0,0-3.36-1.24l-.37-.08-.24-.05a9.48,9.48,0,0,0-2.86-.16h-.15l-.44.07a.88.88,0,0,0-.05.15h0l.5-.07h.08a9.48,9.48,0,0,1,2.71.12l.25.05a4.87,4.87,0,0,1,.52.12A15.84,15.84,0,0,1,166,422.7h0l.32.14c.47.23.95.47,1.42.73s1,.52,1.43.81l.1.06,0,0c.23.13.47.27.7.42s.22.14.34.21h0l.65.41h0l0-.06,0-.06ZM156.49,422l-.54.26c-.27.14-.52.28-.78.44h0c-.35.23-.71.46-1,.72l-.19.15c-.3.24-.58.49-.86.75h0l-.09.08c-.17.16-.33.33-.49.5a3.31,3.31,0,0,0-.39.45c-.13.13-.24.26-.35.39s-.27.32-.4.49h0l-.21.26.09.15.21-.26h0c.33-.42.67-.82,1-1.21.21-.22.42-.44.64-.65l0,0a10.7,10.7,0,0,1,1.09-.93h0a10.77,10.77,0,0,1,1.26-.86h0l.49-.28.07,0,.33-.17.22-.1A.63.63,0,0,0,156.49,422Zm8.68,12.51-.2.14-.05,0h0a9.26,9.26,0,0,1-1,.6l-.36.18,0,0-.38.17h0l-.42.17-.42.14a7.67,7.67,0,0,1-1.75.41c-.23,0-.46,0-.69,0h0a6.94,6.94,0,0,1-.79,0l.1.07.08,0,.08.05h0a7.12,7.12,0,0,0,.8,0h0a3,3,0,0,0,.42,0,10.06,10.06,0,0,0,2.69-.75h0a10.13,10.13,0,0,0,1.53-.8l.24-.26h0l0,0h0l.06-.07.07-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,424.4l-.92-.74-1.87-1.47q-1.87-1.45-3.8-2.83c-.73-.52-1.44-1.08-2.19-1.57a0,0,0,0,0,0,.06c.59.52,1.23,1,1.85,1.5s1.23,1,1.86,1.49c1.24,1,2.51,1.92,3.78,2.85.36.26.71.54,1.08.79l.55.39c.2.12.4.23.58.36a0,0,0,1,0,0,0C170.18,424.94,169.89,424.66,169.58,424.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,423.26a30.09,30.09,0,0,0-1.07,3.62c-.15.6-.27,1.22-.39,1.83a14,14,0,0,0-.24,1.84s0,0,0,0a18.44,18.44,0,0,0,.46-1.81c.14-.61.29-1.21.43-1.82.27-1.21.59-2.42.83-3.65C158.26,423.24,158.21,423.22,158.19,423.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.51,436.18a3.92,3.92,0,0,1-2.3,1c-4.23,0-10.34-10.67-12.46-15.26-1.31-2.84-1.32-5.41-.13-6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,445l-.09,0-.11,0-.22-.27h-2.85l-.34.13a1.47,1.47,0,0,0,.1-.13h-3.41c0,.08-.05.15-.08.22l-1.3-.22H129.62c.1-.6.24-1.35.42-2.21s.34-1.57.56-2.46l0-.14,0-.12.09-.36c.15-.61.32-1.25.5-1.91a.43.43,0,0,1,0-.11h0a.83.83,0,0,1,.06-.21c.07-.29.15-.58.25-.88.22-.82.47-1.67.75-2.53s.59-1.87.92-2.82h0l0-.1c.54-1.51,1.13-3,1.79-4.53h0a.26.26,0,0,1,0-.1h0c.41-.94.84-1.87,1.3-2.76.16-.29.3-.58.45-.87h0a34.66,34.66,0,0,1,2.21-3.59l.09-.13a21.92,21.92,0,0,1,1.94-2.34l.1-.09.2-.21c.18-.18.37-.35.56-.51l.46-.4.46-.35a4.4,4.4,0,0,1,2.64-.76,6.64,6.64,0,0,1,1.61.21,5.71,5.71,0,0,1,1.24.48,3.82,3.82,0,0,1,.76.49,3,3,0,0,1,.31.3.79.79,0,0,1,.12.15l0,.06c.05.07.1.14.14.21l.13.19h0v0s0,0,0,0a.56.56,0,0,1,.05.08,21.26,21.26,0,0,1,1.53,3.13h0l.07.14h0c0,.11.08.23.13.35.3.79.59,1.63.87,2.51h0c.08.29.17.57.26.87l.21.75h0a.55.55,0,0,1,.05.17c.46,1.67.88,3.42,1.25,5.19h0a.85.85,0,0,1,0,.17v0c.11.48.2,1,.3,1.44.06.29.11.59.17.88h0c.11.55.22,1.09.3,1.63l0,.14s0,.05,0,.07,0,.27.07.4c.07.4.14.8.2,1.19l0,.16c.11.7.22,1.39.33,2.05.36,2.37.63,4.46.81,6l0,.29a.34.34,0,0,1,0,.1c0,.21.05.41.07.59Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,444.84l-.47-.57-.08-.09v0l-.08-.09a15.37,15.37,0,0,0-1.46-1.45,9.72,9.72,0,0,0-1.25-1,7.67,7.67,0,0,0-1.63-.79l-.35-.1-.09,0-.07,0-.38-.08a2.71,2.71,0,0,0-.4,0h-.05l-.45,0a8.76,8.76,0,0,0-2.45.24h0l-.4.11c-.25.06-.48.14-.72.22a16.58,16.58,0,0,0-3.22,1.65c-.35.23-.7.46-1,.71h0a2.61,2.61,0,0,0-.27.19l-.14.1h0l-.18.14h0l-.22.17-1,.76h.1l1-.74.23-.16h0l.17-.13h0l.33-.23.09-.07h0l1-.66a16.23,16.23,0,0,1,3.22-1.63,6.36,6.36,0,0,1,.62-.19,3,3,0,0,1,.4-.11h0a8.41,8.41,0,0,1,2.5-.26l.25,0h.23c.14,0,.28,0,.42.06l.37.07.07,0,.09,0,.34.1a7.44,7.44,0,0,1,1.6.79l0,0h0a9.63,9.63,0,0,1,1.24,1,15.75,15.75,0,0,1,1.41,1.42l0,0,0,0,.06.07c.16.18.32.37.47.56l.22.27.11,0Zm-4.22-10.63h0l-.12-.06-.79-.45h0l-.42-.24-.12.08.2.11h0c.44.26.87.51,1.33.74Zm4.39,9.94-.7,0h-.16a8.8,8.8,0,0,0-2.52.63h0l0,0h0a1.47,1.47,0,0,1-.1.13l.34-.13a9.28,9.28,0,0,1,2.12-.53l.26,0H156l.65,0A.34.34,0,0,0,156.68,444.15Zm-6.74-27.68s0,0,0,0v0l-.27.17-.39.25h0L149,417h0l-.5.28c-.19.12-.39.22-.59.32a.27.27,0,0,1-.12.06h0a12.71,12.71,0,0,1-1.29.6h0l-.36.15a11.4,11.4,0,0,1-1.25.41l-.25.07-.21.06c-.32.07-.64.13-1,.18h-.1c-.24,0-.47.06-.72.08l-.44,0h-.9l-.45,0a5.7,5.7,0,0,1-.58-.06,6.58,6.58,0,0,1-.75-.14l-.28-.07-.09.13a10.38,10.38,0,0,0,2.66.34l.81,0,.48-.05.23,0h.11a12.32,12.32,0,0,0,1.21-.24,11.56,11.56,0,0,0,1.25.55,5.43,5.43,0,0,0,.53.17s0,0,0,0a8.58,8.58,0,0,0,1,.24l.16,0h0s0,0,0,0a1,1,0,0,0,0-.1h0l-.18,0a8.56,8.56,0,0,1-1.58-.42l-.35-.13c-.25-.1-.49-.21-.73-.33L145,419h0a10.08,10.08,0,0,0,1.14-.37l.19-.08h0a12.65,12.65,0,0,0,1.4-.65h0a.28.28,0,0,0,.11-.05c.33-.18.66-.36,1-.55h0l.22-.13.08,0,.07,0,.08-.05s0,0,0,0l.65-.41h0Zm1.59,3.22h0l-.15,0-.32.07-.44.09c-.15,0-.3,0-.45.06l-.44.05-.45,0-.49,0-.49,0H148l-.36,0h0l-.18,0a8.56,8.56,0,0,1-1.58-.42l-.35-.13c-.25-.1-.49-.21-.73-.33l-.23-.11-.46-.25c-.22-.12-.43-.25-.64-.39h0l-.06,0-.52-.37c-.26-.18-.51-.36-.75-.56l-.39-.31-.53-.45h0l-.09.1c.22.2.46.4.69.59l.54.43.4.29.65.44.07,0h0l.57.35.33.19c-.32.07-.64.13-1,.18,0,.06,0,.11,0,.17a12.32,12.32,0,0,0,1.21-.24,11.56,11.56,0,0,0,1.25.55,5.43,5.43,0,0,0,.53.17s0,0,0,0a8.58,8.58,0,0,0,1,.24l.16,0h0a1.73,1.73,0,0,0,.32,0h0l.12,0h.19q.31,0,.63,0a8.44,8.44,0,0,0,.87,0,4.4,4.4,0,0,0,.51-.05c.24,0,.48-.06.72-.11l.48-.11h0l.11,0h0A.42.42,0,0,1,151.53,419.69Zm-2.42,12.66a.82.82,0,0,0,.06.19l.55.34.33.05Zm2-5.83c-.37.49-.72,1-1.06,1.51h0l.06.18c.35-.53.71-1,1.09-1.54h0Zm3.24,3.18h0l-.44.55h0l-.08.09-.17.2h0a18.66,18.66,0,0,1-1.94,2c-.13.13-.26.24-.39.35l-.17.13h0a.31.31,0,0,1-.09.07h0l-.13.11-.14.1.13.08.22-.17.12-.09h0l.08-.06h0l.07-.05c.12-.1.24-.2.35-.31a18.29,18.29,0,0,0,2-2.06h0l.19-.23.05-.06a4,4,0,0,0,.26-.32c.05-.05.09-.11.14-.17h0C154.4,429.82,154.38,429.76,154.37,429.7Zm-3.15-3-.09-.15c-.37.49-.72,1-1.06,1.51h0l.06.18c.35-.53.71-1,1.09-1.54Zm-2.05,5.87.55.34.33.05-.94-.58A.82.82,0,0,0,149.17,432.54Zm2-6c-.37.49-.72,1-1.06,1.51h0l.06.18c.35-.53.71-1,1.09-1.54h0Zm-.46,6.94-.17.11a6.11,6.11,0,0,1-.65.38l-.2.11a1.76,1.76,0,0,1-.2.09l-.42.18a6.09,6.09,0,0,1-.86.25,10.06,10.06,0,0,1-2.13.21h-.18a10.83,10.83,0,0,1-1.27-.08,16.38,16.38,0,0,1-3.5-.84c-1.14-.39-2.25-.87-3.36-1.35a28.79,28.79,0,0,0-3.39-1.28,9.26,9.26,0,0,0-1-.25l0,.1a9.26,9.26,0,0,1,1,.25,27,27,0,0,1,3.38,1.29c1.11.47,2.22,1,3.36,1.36a17.58,17.58,0,0,0,3.54.85c.39,0,.78.07,1.18.08H146a10.65,10.65,0,0,0,2.25-.21c.3,0,.59-.17.89-.25l.41-.18a1.63,1.63,0,0,1,.19-.09h0l.2-.11.48-.26.14-.09.17-.12.1-.07Zm-1.56-1.11a.82.82,0,0,0,.06.19l.55.34.33.05Zm0,0h0c-.36-.22-.71-.45-1.06-.68l-.07.11,1.2.76A.82.82,0,0,1,149.11,432.35Zm3.95-8-.09.08c-.17.16-.33.33-.49.5a3.31,3.31,0,0,0-.39.45c-.13.13-.24.26-.35.39s-.27.32-.4.49h0l-.21.26c-.37.49-.72,1-1.06,1.51h0q-.72,1.09-1.38,2.22c-.06.1-.12.2-.17.3h0c-.21.34-.41.68-.61,1l.13.08.55-.92c.07-.14.15-.27.23-.41.42-.71.86-1.43,1.31-2.12.35-.53.71-1,1.09-1.54h0l.21-.26h0c.33-.42.67-.82,1-1.21.21-.22.42-.44.64-.65l0,0A.55.55,0,0,0,153.06,424.34Zm-3.89,8.2a.82.82,0,0,1-.06-.19h0c-.36-.22-.71-.45-1.06-.68l-.07.11Zm1.4.7h0l-.27-.17h0l-.21-.13h0l-.33-.05h0l.22.14h0a0,0,0,0,1,0,0l.28.17.41.25.12-.09Zm-1.46-.89h0c-.36-.22-.71-.45-1.06-.68l-.07.11,1.2.76A.82.82,0,0,1,149.11,432.35Zm1.46.89h0l-.27-.17h0l-.21-.13h0l-.33-.05h0l.22.14h0a0,0,0,0,1,0,0l.28.17.41.25.12-.09Zm-3.23-.68-.1.14-.12.2a0,0,0,0,1,0,0,2.53,2.53,0,0,1-.13.22l-.14.24c-.32.48-.64,1-1,1.42a1,1,0,0,1-.09.13,14,14,0,0,1-1.11,1.33,8.86,8.86,0,0,1-1.35,1.17l-.18.13-.2.12-.38.22a8.67,8.67,0,0,1-.83.36,11.46,11.46,0,0,1-3.54.57,16,16,0,0,1-3.58-.41c-1.09-.23-2.18-.55-3.26-.86l-.06,0h0l0,.11h0l.09,0,.73.21,1.63.44c.29.08.59.14.89.21a16,16,0,0,0,3.6.41,11.22,11.22,0,0,0,3.58-.57,5.18,5.18,0,0,0,.84-.36l.39-.23.2-.11.19-.14a8.13,8.13,0,0,0,1.37-1.19,13.36,13.36,0,0,0,1.19-1.42l.09-.13c.32-.44.62-.89.91-1.34a.6.6,0,0,0,.09-.15s.05-.05.05-.08a.16.16,0,0,0,0-.07h0a.94.94,0,0,0,.12-.22h0a1.28,1.28,0,0,0,.11-.2h0a.64.64,0,0,0,.08-.14c.17-.26.33-.53.49-.8l-.12-.08C147.68,432,147.5,432.27,147.34,432.56Zm3.23.68h0l-.27-.17h0l-.21-.13h0l-.33-.05h0l.22.14h0a0,0,0,0,1,0,0l.28.17.41.25.12-.09Zm4.91,2.42c-.64-.23-1.3-.51-1.93-.81l-.43-.21h0l-.21-.1-.59-.3,0,0h0l-.12-.06-.79-.45h0l-.42-.24-.12.08.2.11h0c.44.26.87.51,1.33.74h0l.29.16.2.09h0a1.23,1.23,0,0,0,.23.11,3.75,3.75,0,0,0,.4.21,21,21,0,0,0,2,.84Zm-4.91-2.42h0l-.27-.17h0l-.21-.13h0l-.94-.58h0c-.36-.22-.71-.45-1.06-.68l-.07.11,1.2.76.55.34h0l.22.14h0a0,0,0,0,1,0,0l.28.17.41.25.12-.09Zm-3.26-2a59.11,59.11,0,0,0-6.24-3.69l-.11-.05h0l-.15-.07h0c-.2-.1-.41-.19-.61-.27a13.19,13.19,0,0,0-1.6-.56c-.3-.08-.61-.15-.92-.21a7.39,7.39,0,0,0-1.82-.09l-.45.05-.24,0h0a.26.26,0,0,0,0,.1h.08l.22,0,.45-.06a7.61,7.61,0,0,1,1.78.1c.26.05.51.1.76.17l.14,0,.7.22a.49.49,0,0,1,.17.06c.25.08.49.18.73.28l.08,0,.53.23h0l0,0,.16.07.11.05h0a58,58,0,0,1,6.2,3.7l.61.39.06-.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.6,444.84h-.43l-.07.05,0,0h0l0,0h0s0,0-.08,0l0,0,0,0-.07-.07h-7.54c-.19.08-.38.14-.56.2l-.09,0-.11,0-.22-.27h-1.69c.3-.18.62-.36,1-.53l.2-.1.06,0,0,0c.23-.11.46-.21.7-.3s.73-.27,1.12-.39a9.67,9.67,0,0,1,6.4.69h0l.16.07.09,0h0l.06,0h0c.28.13.57.27.83.41h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,444.71a1,1,0,0,1-.18.13l-.07.05,0,0h0l0,0h0l0,0,0,0h0l.05,0h0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,437.87a30.1,30.1,0,0,1-1.43,4.75.49.49,0,0,0,0,.11,12.07,12.07,0,0,1-1.07,2.09h0v0h-3.41c0,.08-.05.15-.08.22l-1.3-.22h-.11c-.88-.16-1.85-.34-2.88-.55l-.11,0c-1.09-.22-2.23-.47-3.4-.75h0l-.09,0h0A46.13,46.13,0,0,1,131,439.69l-.25-.14c-.35-.2-.68-.41-1-.62s-.4-.29-.58-.44a2.1,2.1,0,0,1-.7-1.59s0-.07,0-.11,0-.23,0-.35a8.28,8.28,0,0,1,.5-2.35,1.21,1.21,0,0,1,0-.18,26.53,26.53,0,0,1,1.16-2.71h0a.61.61,0,0,0,0-.12h0c.53-1.05,1.15-2.14,1.83-3.26h0a1.74,1.74,0,0,1,.11-.18c.83-1.34,1.74-2.71,2.69-4,.21-.29.43-.58.63-.87h0c1-1.34,2-2.62,3-3.78,0-.05.08-.09.1-.13l.65-.76a7.08,7.08,0,0,1,1.77-1.47l.12-.07h0l.27-.15a2.12,2.12,0,0,1,1-.21c.53.05.91.45,1,1.41a5.28,5.28,0,0,1,0,.68,0,0,0,0,1,0,0,.76.76,0,0,1,0,.15c0,.24,0,.5-.1.78l0,.17h0c-.07.38-.17.8-.29,1.27-.19.71-.39,1.41-.59,2.08h0q-.13.45-.27.87c-.45,1.4-.92,2.68-1.35,3.8l0,.09h0a40,40,0,0,0-1.58,4.25c.06.47,3.86.92,7.83,1.4l.15,0h0l2.31.29,1.05.13.2,0,.3,0h0l.32,0h0l.78.11.52.08.49.09h.07l.11,0h0a13.51,13.51,0,0,1,1.93.46,1.47,1.47,0,0,1,.62.33C156.21,435.19,156.13,436.4,155.84,437.87Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.85,442.57c-.58.85-2.51-.33-4.11-1.53l0,0-.24-.18h0l-.32-.25c.23.2.46.43.71.66v0c.31.31.63.64.91,1l.19.24.09.11q.09.12.06.09l.12.17,0,0,.11.15.08.12c0,.06.06.08,0,.05l0,.07.08.11h0v0s0,0,0,0h0a0,0,0,0,1,0,0,2,2,0,0,1,.31,1.37h-2.56c-.17-.11-.35-.24-.53-.38l-.41-.31.09.14h0a3.92,3.92,0,0,1,.33.54h-3.7l-.07.05a.07.07,0,0,0,0,0l0,0-.13-.1.08.1s0,0,0,0h0l0,.05h0l0,0h0s0,0-.08,0l0,0,0,0-.07-.07h-4.64c-.6-.51-1-.89-1-.89a13.29,13.29,0,0,1-1.9.89c-.19.08-.38.14-.56.2l-.09,0-.11,0-.22-.27h-2.85l-.34.13a1.47,1.47,0,0,0,.1-.13h-3.11a26.11,26.11,0,0,1,1-4s0-.06,0-.09c.53-1.77,1.16-3.72,1.6-5.07.11-.35.21-.66.31-.92a.5.5,0,0,1,0-.13h0c.13-.39.22-.62.22-.62h3.55c1.29,0,2.71,0,3.88.08.37,0,.8,0,1.26.09l1.25.15h.07l.11,0,.19,0a5.67,5.67,0,0,1,.57.1l.18,0,.57.13h.09a6.52,6.52,0,0,1,1.34.45,30.18,30.18,0,0,1,6.39,4.94l.35.41a2.47,2.47,0,0,1,.22.29l.16.22a.6.6,0,0,1,.09.13C174,441.69,174.1,442.21,173.85,442.57Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.57,437.47c.7.51,1.41,1,2.07,1.58a24.41,24.41,0,0,1,1.89,1.78,14.39,14.39,0,0,1,2.11,2.64,32.55,32.55,0,0,0-4.16-4.25c-.66-.56-1.28-1.16-1.94-1.72A0,0,0,0,1,165.57,437.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.48,439.81c.87.68,1.76,1.32,2.6,2.05s2,1.76,2.76,2.53c.06.06,0,.17-.06.12-.82-.74-2-1.76-2.85-2.49s-1.62-1.5-2.47-2.19C163.45,439.81,163.47,439.8,163.48,439.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.09,445s0,0-.08,0l0,0,0,0-.07-.07-.71-.68h0c-.87-.84-1.7-1.62-2.87-2.63,0,0,0-.06,0,0a21.26,21.26,0,0,1,3.09,2.77c.19.19.37.38.55.58h0s0,0,0,0l0,.05h0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.36,444.75l.16.09h-.36l-.38-.33-.09-.08-.15-.14-.41-.39s.05,0,.08,0,.39.33.63.5A4.55,4.55,0,0,0,169.36,444.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,433.43v0l-.18.42,0,0,0,.07-.25.55h0l0,.12-.24.54L151,438.84l-.77,1.74h0l0,.08h0l-1.82,4.14v0h-3.66c-1-.25-2.12-.55-3.34-.9h0l-.08,0h0a61,61,0,0,1-10.4-3.75l-.24-.13a9.37,9.37,0,0,1-1-.56,4.63,4.63,0,0,1-1.41-1.3.93.93,0,0,1,0-.1,2.44,2.44,0,0,1-.1-.24,3.33,3.33,0,0,1-.13-1,.38.38,0,0,1,0-.1,1.07,1.07,0,0,1,0-.25,9.48,9.48,0,0,1,.59-2.53,4.15,4.15,0,0,1,.18-.53,19.82,19.82,0,0,1,.82-1.9.78.78,0,0,1,0-.14l.47-.95c.31-.58.63-1.18,1-1.78l.14-.25h0c.93-1.59,2-3.21,3.12-4.77l.64-.87h0c1.05-1.4,2.13-2.72,3.18-3.91l0-.05.06-.07a14.14,14.14,0,0,1,2.52-2.31l.12-.08a3.12,3.12,0,0,1,1.06-.45,1.15,1.15,0,0,1,.45,0c.65.1,1,.78,1,1.77a3.8,3.8,0,0,1,0,.68v.17c0,.23,0,.47-.07.72,0,.06,0,.11,0,.17a15.66,15.66,0,0,1-.45,2.06c-.12.43-.26.87-.39,1.31h0l-.13.39-.15.48a2.58,2.58,0,0,1-.08.26c-.22.66-.44,1.32-.66,2l0,.1c-.19.54-.37,1.07-.54,1.57h0a.24.24,0,0,1,0,.08v0c-.75,2.15-1.31,3.77-1.18,4s3.94.72,7.5,1.16l.15,0h0l1.89.24.66.07h.16l.15,0h0l.77.09h0l.19,0h0l.69.08c.78.09,1.3.15,1.42.15h0Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.19,440.58l-.45,0a8.76,8.76,0,0,0-2.45.24h0l-.4.11c-.25.06-.48.14-.72.22a16.58,16.58,0,0,0-3.22,1.65c-.35.23-.7.46-1,.71h0a2.61,2.61,0,0,0-.27.19l-.14.1h0l-.18.14.08,0h0l.17-.13h0l.33-.23.09-.07h0l1-.66a16.23,16.23,0,0,1,3.22-1.63,6.36,6.36,0,0,1,.62-.19,3,3,0,0,1,.4-.11h0a8.41,8.41,0,0,1,2.5-.26l.25,0,.22,0h0l0-.08h-.05Zm-6.88-21.41c-.24,0-.47.06-.72.08l-.44,0h-.9l-.45,0a5.7,5.7,0,0,1-.58-.06,6.58,6.58,0,0,1-.75-.14l-.28-.07h0l-.16,0-.42-.14-.32-.12-.06.07,0,.05.33.13.48.16.11,0a10.38,10.38,0,0,0,2.66.34l.81,0,.48-.05.23,0h.11c0-.06,0-.11,0-.17Zm.17-.9-.06,0c-.18-.11-.35-.23-.52-.35s-.51-.36-.75-.56l-.39-.31-.53-.45h0l-.06-.05h0l-.22-.21-.12.08.22.2.1.08c.22.2.46.4.69.59l.54.43.4.29.65.44.06.05h0v-.07a.28.28,0,0,0,0-.09h0Zm7.59,14.89h0l-.13.11-.14.1-.12.09-.17.11a6.11,6.11,0,0,1-.65.38l-.2.11a1.76,1.76,0,0,1-.2.09l-.42.18a6.09,6.09,0,0,1-.86.25,10.06,10.06,0,0,1-2.13.21h-.18a10.83,10.83,0,0,1-1.27-.08,16.38,16.38,0,0,1-3.5-.84c-1.14-.39-2.25-.87-3.36-1.35a28.79,28.79,0,0,0-3.39-1.28,9.26,9.26,0,0,0-1-.25,6.68,6.68,0,0,0-2.56,0,3.9,3.9,0,0,0-.46.12h0c-.21.08-.42.16-.62.26a.78.78,0,0,0,0,.14,4.22,4.22,0,0,1,.61-.28h0l.09,0a3.9,3.9,0,0,1,.46-.12,6.57,6.57,0,0,1,2.5,0h0a9.26,9.26,0,0,1,1,.25,27,27,0,0,1,3.38,1.29c1.11.47,2.22,1,3.36,1.36a17.58,17.58,0,0,0,3.54.85c.39,0,.78.07,1.18.08H146a10.65,10.65,0,0,0,2.25-.21c.3,0,.59-.17.89-.25l.41-.18a1.63,1.63,0,0,1,.19-.09h0l.2-.11.48-.26.14-.09.17-.12.1-.07.12-.08.22-.17.12-.09h0Zm-.5.08h0l-.27-.17h0l-.15,0H150a0,0,0,0,1,0,0l.28.17.41.25.12-.09Zm0,0h0l-.27-.17h0l-.15,0H150l.28.17.41.25.12-.09Zm-3.18-.52-.15,0-.12.2a0,0,0,0,1,0,0,2.53,2.53,0,0,1-.13.22l-.14.24c-.32.48-.64,1-1,1.42a1,1,0,0,1-.09.13,14,14,0,0,1-1.11,1.33,8.86,8.86,0,0,1-1.35,1.17l-.18.13-.2.12-.38.22a8.67,8.67,0,0,1-.83.36,11.46,11.46,0,0,1-3.54.57,16,16,0,0,1-3.58-.41c-1.09-.23-2.18-.55-3.26-.86l-.06,0h0l-.16,0-1.34-.38h0c-.42-.11-.84-.22-1.27-.31h0l-.49-.1h0v.1l.51.11c.44.09.87.2,1.3.32l1.3.37.15.05h0l.09,0h0l.73.21,1.63.44c.29.08.59.14.89.21a16,16,0,0,0,3.6.41,11.22,11.22,0,0,0,3.58-.57,5.18,5.18,0,0,0,.84-.36l.39-.23.2-.11.19-.14a8.13,8.13,0,0,0,1.37-1.19,13.36,13.36,0,0,0,1.19-1.42l.09-.13c.32-.44.62-.89.91-1.34a.6.6,0,0,0,.09-.15s.05-.05.05-.08l0-.07a1.27,1.27,0,0,0,.13-.22h0a1.13,1.13,0,0,0,.13-.2Zm3.18.52h0l-.27-.17h0l-.15,0H150l.28.17.41.25.12-.09Zm1.75,1,0,0h0l-.12-.06-.79-.45h0l-.42-.24-.13-.08-.22-.13h0l-.27-.17h0l-.15,0H150a0,0,0,0,1,0,0l.28.17.41.25.13.07.2.11h0c.44.26.87.51,1.33.74h0l.29.16.2.1h0l.06-.11ZM141,427.46l-.15-.07h0c-.2-.1-.41-.19-.61-.27a13.19,13.19,0,0,0-1.6-.56c-.3-.08-.61-.15-.92-.21a7.39,7.39,0,0,0-1.82-.09l-.45.05-.24,0h0l-.21,0c-.29.06-.58.18-.87.27a8.37,8.37,0,0,0-1.83.95,10.06,10.06,0,0,0-1,.74h0l-.14.25a9.58,9.58,0,0,1,1-.8h0a8.92,8.92,0,0,1,2-1c.28-.09.56-.2.86-.27l.14,0,.08,0,.22,0,.45-.06a7.61,7.61,0,0,1,1.78.1c.26.05.51.1.76.17l.14,0c.24.06.47.14.7.22a.49.49,0,0,1,.17.06c.25.08.49.18.73.28l.08,0,.53.23h0l.16.07v0a.11.11,0,0,1,0-.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.86,443.63c.19-.35.36-.7.54-1.05l1.06-2.13c.7-1.42,1.35-2.85,2-4.3.37-.82.76-1.63,1.09-2.46a0,0,0,1,0-.06,0c-.39.69-.73,1.41-1.1,2.12s-.73,1.41-1.08,2.12q-1,2.13-2,4.29c-.19.4-.39.8-.55,1.21-.09.21-.19.42-.27.63s-.15.43-.24.64c0,0,0,0,0,0C145.46,444.33,145.67,444,145.86,443.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.19,444.84H144l-1.32-.32c-.52-.13-1-.27-1.57-.42l-.08,0c-1.2-.32-2.4-.68-3.58-1.06a46.89,46.89,0,0,1-5.1-1.94q-.78-.36-1.53-.78l-.24-.13c-.21-.13-.42-.25-.63-.39a3.62,3.62,0,0,1-.32-.22,6.43,6.43,0,0,1-.76-.62,3.32,3.32,0,0,1-.63-.77.93.93,0,0,1,0-.1,2.44,2.44,0,0,1-.1-.24,2.92,2.92,0,0,0,.85,1,5.9,5.9,0,0,0,.73.5,3.26,3.26,0,0,0,.4.24,6.28,6.28,0,0,0,.57.31l.25.13c.52.27,1.06.5,1.6.73,1.66.69,3.37,1.28,5.09,1.83,1.28.41,2.57.8,3.86,1.17h0a.11.11,0,0,0,.08,0h0l1.23.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19,433.91l.19-.49,0,0q-2.84-.18-5.65-.47c-1.89-.2-3.76-.42-5.64-.7-.47-.07-.93-.15-1.4-.24a6,6,0,0,1-.71-.16l-.19-.06-.11,0-.07,0a.32.32,0,0,1-.06-.08.08.08,0,0,1,0,0,0,0,0,0,1,0,0,.88.88,0,0,1,0-.25,1.29,1.29,0,0,0,0-.19c.24-.93.54-1.82.85-2.72q.93-2.69,2-5.31c-.55,1.81-1.11,3.61-1.67,5.42-.26.9-.56,1.8-.76,2.7,0,.06,0,.11,0,.17s0,.12,0,.09h0s0,0,0,0l0,0s0,0,0,0l.05,0,.15,0c.22.06.45.11.68.15.46.09.92.16,1.39.23.93.14,1.86.27,2.8.39l2.81.38c1.87.25,3.74.52,5.61.79h0l0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63,424.26a4.62,4.62,0,0,1-.5.9,3.89,3.89,0,0,1-.68.78,9.8,9.8,0,0,1,.55-.87A6.07,6.07,0,0,1,142.63,424.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.12,420.08c-1.6.46-4.48-1.88-5.66-3.83-.08-.14.24-5.64.19-6.74,0-.22,6.95,1.36,6.95,1.36a17.53,17.53,0,0,0-.47,4.25C149.14,415.28,149.66,419.64,148.12,420.08Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.55,413a8.11,8.11,0,0,0,6.57,1.38,18.61,18.61,0,0,1,.49-3.47s-7-1.58-7-1.36C142.67,410,142.61,411.51,142.55,413Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,406.34a2.62,2.62,0,1,0,2.26-3.23A2.81,2.81,0,0,0,149.57,406.34Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.75,406.53a2.91,2.91,0,1,0,2.51-3.58A3.11,3.11,0,0,0,148.75,406.53Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,401.24c-.76,2.44.49,9.51,2.22,11.09,2.5,2.3,6.63,2.54,8.58-.48s.11-12.1-1.82-13.54C147.81,396.19,142.81,397.64,141.68,401.24Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,405.68s0,0,0,.05c.1.47.15,1-.25,1.27,0,0,0,0,0,0C147.8,406.85,147.73,406.11,147.56,405.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,405.27c-.78.08-.54,1.63.17,1.54S147.69,405.19,147,405.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,405.31s0,0,0,0c.05.48.2,1,.66,1.11,0,0,0,0,0,0C150.47,406.49,150.28,405.77,150.3,405.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,404.75c.76-.18,1.06,1.35.35,1.51S150,404.89,150.65,404.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.32,404.65a4.44,4.44,0,0,0,.57-.3,1.07,1.07,0,0,0,.52-.42.32.32,0,0,0-.12-.38.81.81,0,0,0-.82,0,1.16,1.16,0,0,0-.61.62C145.73,404.49,146.06,404.76,146.32,404.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,403.88a4.34,4.34,0,0,1-.63-.07,1,1,0,0,1-.64-.19.32.32,0,0,1,0-.4.78.78,0,0,1,.78-.27,1.17,1.17,0,0,1,.79.34A.35.35,0,0,1,151.13,403.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.82,410.16c.13.09.27.23.44.22a1.35,1.35,0,0,0,.5-.2s0,0,0,0a.64.64,0,0,1-.57.35.49.49,0,0,1-.43-.36S147.8,410.14,147.82,410.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,408.65a1.64,1.64,0,0,0,1.2.56,2,2,0,0,0,.59-.06l.11,0,.1,0a.13.13,0,0,0,.08-.12h0v0h0v0c0-.37-.17-.92-.17-.92s.88.25.84.06a24.85,24.85,0,0,0-1.38-4.83c0-.05-.09,0-.08,0,.26,1.53.79,3,1.08,4.54a3,3,0,0,0-.8-.12c-.05,0,.25,1.06.26,1.23v0a2.26,2.26,0,0,1-1.76-.27S148.07,408.62,148.1,408.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.64,409a1.92,1.92,0,0,1-.68.71.77.77,0,0,1-.52.11c-.4,0-.46-.39-.44-.7a1.92,1.92,0,0,1,.11-.48A2.49,2.49,0,0,0,149.64,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,409.71a.77.77,0,0,1-.52.11c-.4,0-.46-.39-.44-.7A.91.91,0,0,1,149,409.71Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.84,403.75c-.27.7-.85,2.35-1.17,2.47a11.67,11.67,0,0,1,.24-5.65,4.69,4.69,0,0,1,1-1.41C142.93,399.77,143.14,403,142.84,403.75Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,400.48a2.28,2.28,0,0,1-1.91,1.12,2.31,2.31,0,0,1-2-1s0,0,0,0a2.32,2.32,0,0,0,2,1.21,2.37,2.37,0,0,0,2-1.28S149,400.45,149,400.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.69,396.84a2.89,2.89,0,0,0-1.5-1.32,4,4,0,0,0-2.64.13s0,.05,0,0a4,4,0,0,1,2.28-.15,2.87,2.87,0,0,1,1.54,1.13,2.74,2.74,0,0,1-2.67,4.22s-.05,0,0,.05a2.84,2.84,0,0,0,3-4.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,402.65s-1.64-2.1-.84-3.62c.45-.86,2.4-1.1,2.4-1.1a3.76,3.76,0,0,1,2-1.65,7.41,7.41,0,0,1,3.62-.26,3.27,3.27,0,0,1,3-.58,3,3,0,0,1,.65,5.23c-1.3.94-3.45,0-3.45,0-.18.06-1.88,1.54-3.61.09,0,0-1,1.24-2.15.7A1.72,1.72,0,0,1,141.48,402.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.16,407s-1.63-2.26-2.66-1.67.22,3.87,1.44,4.31a1.25,1.25,0,0,0,1.65-.69Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.88,406.26s0,0,0,0a3.13,3.13,0,0,1,1.64,1.93.68.68,0,0,0-1-.17s0,.05,0,0a.77.77,0,0,1,.84.25,3.62,3.62,0,0,1,.41.68c0,.07.18,0,.15-.06v0C142.92,407.86,142.05,406.36,140.88,406.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.8,405.41s-.88-3.51-.19-5.66a5.78,5.78,0,0,1,7-3.73,8.21,8.21,0,0,0-5.61,3.64c-.84,1.44,0,5.63,0,5.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,406.6a2.94,2.94,0,1,1-3.49-2.72A3.13,3.13,0,0,1,145.45,406.6Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.6,406.66a2.65,2.65,0,1,1-3.14-2.45A2.82,2.82,0,0,1,144.6,406.66Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.58,
    y: 413.25,
    width: 9.26,
    height: 0.36,
    transform: "translate(-271.33 460.6) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.91,418a2,2,0,0,1-.58-.09l-3.11-.94.2-.64,3.11.95a1.27,1.27,0,0,0,1-.1,1.25,1.25,0,0,0,.63-.77l1.16-3.8a1.31,1.31,0,0,0-.87-1.63l-3.1-1,.19-.63,3.11.95a2,2,0,0,1,1.16,1,1.91,1.91,0,0,1,.14,1.5l-1.15,3.81a2,2,0,0,1-1.88,1.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.39,
    y: 417.36,
    width: 0.72,
    height: 1.68,
    transform: "translate(-276.92 462.58) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.29,
    y: 407.86,
    width: 0.72,
    height: 1.68,
    transform: "translate(-265.79 458.62) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.67,
    y: 413.8,
    width: 0.66,
    height: 1.56,
    transform: "translate(-269.74 465.06) rotate(-73.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,410.72,173,415.21l-6.18-1.88a2.35,2.35,0,0,1-1.56-2.93h0a2.35,2.35,0,0,1,2.93-1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.25,414.35h0a2.75,2.75,0,0,1-3.45,1.84l-2.5-.76,1.61-5.29,2.5.76A2.76,2.76,0,0,1,178.25,414.35Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.92,
    y: 412.81,
    width: 5.53,
    height: 0.31,
    transform: "translate(-271.96 458.82) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.46,
    y: 412.97,
    width: 5.53,
    height: 0.31,
    transform: "translate(-271.74 459.45) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.44,
    y: 413.9,
    width: 0.52,
    height: 2.56,
    transform: "translate(-272.66 462.26) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.74,
    y: 412.92,
    width: 0.52,
    height: 2.56,
    transform: "translate(-271.51 461.93) rotate(-73.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.03,
    y: 411.95,
    width: 0.52,
    height: 2.56,
    transform: "translate(-270.36 461.52) rotate(-73.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.33,
    y: 410.97,
    width: 0.52,
    height: 2.56,
    transform: "translate(-269.23 461.03) rotate(-73.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.37 422.3 210.35 422.36 210.26 422.94 210.25 422.98 209.06 430.63 209.03 430.79 208.65 433.21 208.63 433.27 208.53 433.91 208.15 436.44 207 443.7 206.85 444.62 206.82 444.84 206.6 444.84 206.65 444.62 206.78 443.7 207.93 436.44 208.31 433.91 208.43 433.26 208.43 433.22 208.81 430.79 208.84 430.63 210.03 423.01 210.06 422.85 210.13 422.39 209.75 422.08 209.47 421.85 208.47 421.04 207.59 420.32 207.13 419.94 194.07 409.29 193.76 409.04 193.47 408.8 193.07 409.02 192.81 409.16 192.74 409.2 192.1 409.54 191.03 410.12 190.25 410.54 189.63 410.87 188.59 411.43 188.31 411.58 187.88 411.82 186.84 412.37 186.07 412.79 182.68 414.62 181.78 415.11 181.01 415.51 180.07 416.02 179.97 415.83 181.07 415.23 181.88 414.8 182.78 414.32 185.82 412.68 186.59 412.26 187.85 411.58 187.88 411.57 188.59 411.19 189.18 410.87 190 410.42 190.78 410.01 192.04 409.33 192.68 408.99 192.81 408.92 192.87 408.89 193.5 408.54 193.56 408.58 193.99 408.92 194.07 409 207.47 419.94 207.59 420.03 208.47 420.75 209.72 421.78 209.79 421.84 210.37 422.3",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 421.89 211.38 421.95 211.26 422.64 211.24 422.82 210.01 430.62 209.99 430.81 209.6 433.2 209.59 433.29 209.5 433.91 209.09 436.44 207.96 443.7 207.81 444.62 207.78 444.84 207.56 444.84 207.59 444.62 207.74 443.7 208.88 436.44 209.28 433.91 209.38 433.28 209.38 433.2 209.75 430.8 209.76 430.8 209.78 430.62 210.99 422.98 211.03 422.71 211.15 421.98 210.57 421.52 210.34 421.32 208.62 419.94 208.47 419.82 207.59 419.11 194.31 408.4 194.07 408.21 193.47 407.73 192.81 408.09 192.54 408.23 192.44 408.29 191.81 408.62 189.96 409.62 189.18 410.04 188.59 410.35 187.88 410.73 187.63 410.87 186.29 411.58 185.75 411.87 184.99 412.29 183.12 413.29 182.22 413.77 180.78 414.54 180.62 414.63 180.51 414.44 180.57 414.41 182.31 413.48 183.22 412.99 184.74 412.17 185.51 411.76 185.84 411.58 187.16 410.87 188.59 410.11 188.93 409.93 189.71 409.51 191.74 408.42 192.38 408.08 192.59 407.97 192.81 407.85 193.5 407.47 194.07 407.93 194.32 408.13 207.59 418.83 208.47 419.54 208.97 419.94 210.62 421.27 210.63 421.27 210.84 421.44 211.38 421.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,415.2a.9.9,0,1,1-.89-.89A.89.89,0,0,1,181.07,415.2Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.94 444.84 203.69 444.84 203.76 444.62 210.88 444.62 210.94 444.84",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.44,410h0a.64.64,0,0,1-.63-.64v-2.3a.63.63,0,0,1,.63-.63h0a.63.63,0,0,1,.63.63v2.3A.64.64,0,0,1,193.44,410Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.92,422.68h0a.64.64,0,0,1,.42-.79l2.2-.66a.63.63,0,0,1,.79.42h0a.63.63,0,0,1-.42.79l-2.2.67A.63.63,0,0,1,208.92,422.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.34,408.2a.9.9,0,1,1-1.79,0,.9.9,0,0,1,1.79,0Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.63,
    cy: 422.17,
    r: 0.89,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.2 443.7 178.3 443.7 183.37 419.94 215.28 419.94 210.2 443.7",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.38 443.7 179.48 443.7 184.55 419.94 216.46 419.94 211.38 443.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.72,430.44a2.4,2.4,0,0,1-2.28,2,1.65,1.65,0,0,1-1.66-2,2.4,2.4,0,0,1,2.28-2A1.64,1.64,0,0,1,200.72,430.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.71 444.84 196.28 444.84 195.84 443.7 195.84 443.69 193.13 436.58 201.56 436.58 204.26 443.69 204.26 443.7 204.62 444.61 204.62 444.62 204.71 444.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.09 444.84 197.66 444.84 197.22 443.7 197.22 443.69 194.51 436.58 202.94 436.58 205.65 443.69 205.65 443.7 206 444.61 206 444.62 206.09 444.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.24 403.21 210.24 403.21 210.24 392.65 199.57 392.65 199.57 391.65 211.24 391.65 211.24 403.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.66 438.49 129.09 438.49 129.09 426.76 130.09 426.76 130.09 437.49 140.66 437.49 140.66 438.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.24 438.49 199.57 438.49 199.57 437.49 210.24 437.49 210.24 426.76 211.24 426.76 211.24 438.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.09 403.21 129.09 403.21 129.09 391.65 140.66 391.65 140.66 392.65 130.09 392.65 130.09 403.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.01 410.88 184.01 410.88 184.01 407.47 180.56 407.47 180.56 406.47 185.01 406.47 185.01 410.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.73 423.67 155.32 423.67 155.32 419.2 156.32 419.2 156.32 422.67 159.73 422.67 159.73 423.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "185.01 423.67 180.56 423.67 180.56 422.67 184.01 422.67 184.01 419.2 185.01 419.2 185.01 423.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.32 410.88 155.32 410.88 155.32 406.47 159.73 406.47 159.73 407.47 156.32 407.47 156.32 410.88",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85,397.64a2.14,2.14,0,1,1-2.14-2.14A2.14,2.14,0,0,1,207.85,397.64Z",
    style: {
      fill: "#3CC09F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.82 466.9 200.74 466.9 203.81 457.72 135.75 457.72 138.82 466.9",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.12 461.8 202.92 460.37 203.81 457.72 135.75 457.72 137.12 461.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.72,
    y: 466.9,
    width: 22.12,
    height: 8.85,
    transform: "translate(339.56 942.66) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.72 469.12 180.84 470.25 180.84 466.9 158.72 466.9 158.72 469.12",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.43,
    cy: 403.21,
    r: 8.17,
    style: {
      fill: "#37474f",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.85,403.21a6.58,6.58,0,1,0,6.58-6.57A6.58,6.58,0,0,0,227.85,403.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.43,
    cy: 403.21,
    r: 5.3,
    style: {
      fill: "#dbdbdb",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,419.55a3.63,3.63,0,1,0,3.62-3.63A3.62,3.62,0,0,0,230.81,419.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,419.55a2.92,2.92,0,1,0,2.92-2.92A2.92,2.92,0,0,0,231.51,419.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,431.34a3.63,3.63,0,1,0,3.62-3.62A3.63,3.63,0,0,0,230.81,431.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,431.34a2.92,2.92,0,1,0,2.92-2.92A2.92,2.92,0,0,0,231.51,431.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,443.13a3.63,3.63,0,1,0,3.62-3.62A3.63,3.63,0,0,0,230.81,443.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.51,443.13a2.92,2.92,0,1,0,2.92-2.92A2.92,2.92,0,0,0,231.51,443.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.87,
    y: 448.08,
    width: 0.86,
    height: 0.86,
    transform: "translate(496.61 897.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.51,
    y: 448.08,
    width: 0.86,
    height: 0.86,
    transform: "translate(493.88 897.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 448.08,
    width: 0.86,
    height: 0.86,
    transform: "translate(491.14 897.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 448.08,
    width: 0.86,
    height: 0.86,
    transform: "translate(488.41 897.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.41,
    y: 448.08,
    width: 0.86,
    height: 0.86,
    transform: "translate(485.67 897.02) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.87,
    y: 449.45,
    width: 0.86,
    height: 0.86,
    transform: "translate(698.18 201.57) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.87,
    y: 450.81,
    width: 0.86,
    height: 0.86,
    transform: "translate(699.55 202.94) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.87,
    y: 452.18,
    width: 0.86,
    height: 0.86,
    transform: "translate(700.92 204.31) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.87,
    y: 453.55,
    width: 0.86,
    height: 0.86,
    transform: "translate(702.29 205.67) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.51,
    y: 449.45,
    width: 0.86,
    height: 0.86,
    transform: "translate(696.82 202.94) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.51,
    y: 450.81,
    width: 0.86,
    height: 0.86,
    transform: "translate(698.18 204.31) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.51,
    y: 452.18,
    width: 0.86,
    height: 0.86,
    transform: "translate(699.55 205.67) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.51,
    y: 453.55,
    width: 0.86,
    height: 0.86,
    transform: "translate(700.92 207.04) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 449.45,
    width: 0.86,
    height: 0.86,
    transform: "translate(695.45 204.31) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 450.81,
    width: 0.86,
    height: 0.86,
    transform: "translate(696.82 205.67) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 452.18,
    width: 0.86,
    height: 0.86,
    transform: "translate(698.18 207.04) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 453.55,
    width: 0.86,
    height: 0.86,
    transform: "translate(699.55 208.41) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 449.45,
    width: 0.86,
    height: 0.86,
    transform: "translate(694.08 205.67) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 450.81,
    width: 0.86,
    height: 0.86,
    transform: "translate(695.45 207.04) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 452.18,
    width: 0.86,
    height: 0.86,
    transform: "translate(696.82 208.41) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.77,
    y: 453.55,
    width: 0.86,
    height: 0.86,
    transform: "translate(698.18 209.77) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.41,
    y: 449.45,
    width: 0.86,
    height: 0.86,
    transform: "translate(692.72 207.04) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.41,
    y: 450.81,
    width: 0.86,
    height: 0.86,
    transform: "translate(694.08 208.41) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.41,
    y: 452.18,
    width: 0.86,
    height: 0.86,
    transform: "translate(695.45 209.77) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.41,
    y: 453.55,
    width: 0.86,
    height: 0.86,
    transform: "translate(696.82 211.14) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.1,
    y: 382.12,
    width: 14.5,
    height: 2.64,
    transform: "translate(470.69 766.87) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.59,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(482.56 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.61,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(478.61 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.63,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(474.65 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.66,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(470.69 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.68,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(466.74 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.7,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(462.78 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.72,
    y: 382.66,
    width: 1.38,
    height: 1.56,
    transform: "translate(458.83 766.87) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.22,
    y: 364.99,
    width: 13.27,
    height: 4.08,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.01,
    y: 367.47,
    width: 15.69,
    height: 1.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.32 376.11 177.12 376.11 174.98 356.37 142.46 356.37 140.32 376.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.26,
    y: 359.55,
    width: 22.91,
    height: 14.81,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.08,
    y: 361.34,
    width: 19.27,
    height: 11.22,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.33,367a5.61,5.61,0,1,1-5.61-5.61A5.61,5.61,0,0,1,164.33,367Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.5,
    y: 475.75,
    width: 10.56,
    height: 24.25,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.53 453.97 113.53 443.14 111.53 443.77 111.53 453.34 113.53 453.97",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocucaogravada);
export default __webpack_public_path__ + "static/media/locucaogravada.75832d255579fdaa6993e818436612e4.svg";
export { ForwardRef as ReactComponent };